const schema = {
  "1e_Alarm": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aant.Vracht/tankw.GS": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_aanhoudingen": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_daders": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_dieren": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_doden": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Vastgesteld door de arts of hoofd van de romp gescheiden.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_gewonden": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Er is sprake van enig lichamelijk letsel.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_in_object": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_niet_Zelfredz": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_personen": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_te_water": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Aantal mensen dat te water is geraakt waarbij het vermoeden is dat ze er niet zelfstandig uit kunnen komen.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_vermisten": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Aantal betrokkenen dat vermist wordt. ",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_voertuigen_li": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantal_voertuigen_zw": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Aantref/lek_gev.stof": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Asbest",
      "Drugs",
      "Explosieven/Munitie",
      "Gaslek Verwarm/aandr",
      "Gaslucht",
      "Gedumpt afval",
      "Gevaarlijke stof",
      "Koolmonoxide",
      "Radioactiviteit",
      "Verdacht pakket",
      "Vreemde lucht"
    ]
  },
  "Achtervolging": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Regionaal",
      "Regio-overschrijdend",
      "Grens-overschrijdend"
    ]
  },
  "Ademhaling": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Aanwezig",
      "Afwezig",
      "Diepe",
      "Hoorbaar benauwd",
      "Oppervlakkig",
      "Reutelend",
      "Snel",
      "Snel met tussenpose",
      "Snurkend",
      "Weet niet"
    ]
  },
  "Afkruisen": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Rijstrook 1",
      "Rijstrook 2",
      "Rijstrook 3",
      "Rijstrook 4",
      "Rijstrook 5",
      "Rijstrook 6",
      "Rijstrook 7"
    ]
  },
  "Afstemverzoek": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Alarm_oorzaak": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "Afwijkend gebruik staat voor verkeerd gebruik van ruimte of verkeerde bediening heeft de installatie doen afgaan.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Afwijkend gebruik",
      "Brand",
      "Incident gev. Stof",
      "Niet te achterhalen",
      "Ontwerpfout"
    ]
  },
  "Alarmeringsfase": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "1",
      "2"
    ]
  },
  "Ambu_in_nood": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Beknel/Bedel/Insluit": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Bericht_alle_Eenh": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Beschadig_Strooml": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Betreft": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Bevestigd": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "Was geverifieerd",
    answer_options: [
      "Audio",
      "Geen contact",
      "In persoon",
      "Meerdere zones",
      "Nee",
      "Technisch",
      "Video"
    ]
  },
  "Bewustzijn": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Aanspreekbaar",
      "Niet aanspreekbaar"
    ]
  },
  "Bijst_Pel_Basis_Pel": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor bijstand leveren en vragen",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. Basis",
      "2 Pel. Basis",
      "3 Pel. Basis",
      "4 Pel. Basis"
    ]
  },
  "Bijst_Pel_GW": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor bijstand leveren en vragen",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. GW G3000",
      "2 Pel. GW G3000"
    ]
  },
  "Bijst_Pel_HV": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor bijstand leveren en vragen",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. Redding & THV",
      "2 Pel. Redding & THV",
      "3 Pel. Redding & THV",
      "4 Pel. Redding & THV",
      "STH",
      "SHH-ST / Stut-stemp.",
      "USAR binnenland",
      "USAR buitenland"
    ]
  },
  "Bijst_Pel_IBGS": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor bijstand leveren en vragen",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. IBGS",
      "2 Pel. IBGS",
      "3 Pel. IBGS",
      "4 Pel. IBGS",
      "1 Spec. Pel. IBGS",
      "2 Spec. Pel. IBGS"
    ]
  },
  "Bijst_Pel_IV": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor bijstand leveren en vragen",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. IV"
    ]
  },
  "Bijst_Pel_Log_en_OnS": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor bijstand leveren en vragen",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. Log & Ons",
      "2 Pel. Log & Ons"
    ]
  },
  "Bijst_Pel_NBB": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor bijstand leveren en vragen",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "Stond NBBS",
    answer_options: [
      "1 Pel. NatBr Bestr",
      "2 Pel. NatBr Bestr",
      "3 Pel. NatBr Bestr",
      "4 Pel. NatBr Bestr",
      "5 Pel. NatBr Bestr",
      "6 Pel. NatBr Bestr",
      "1 Pel GW NatBr Bestr",
      "2 Pel GW NatBr Bestr",
      "1 Pel DF NatBr Bestr"
    ]
  },
  "Bijst_Pel_SBB": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor bijstand leveren en vragen",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. SBB",
      "2 Pel. SBB",
      "3 Pel. SBB",
      "4 Pel. SBB"
    ]
  },
  "Bijst_Pel_Spec.Bl.": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor bijstand leveren en vragen",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. Schuim",
      "2 Pel. Schuim",
      "1 Pel. Tank brand",
      "2 Pel. Tank brand",
      "1 Pel. Tankput brand",
      "2 Pel. Tankput brand"
    ]
  },
  "Binnen/buiten": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Binnen",
      "Buiten"
    ]
  },
  "Blikseminslag": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Bloeding": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Geen",
      "Veel",
      "Weinig"
    ]
  },
  "Botbreuk": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Geen",
      "Gecompliceerd",
      "Niet gecompliceerd",
      "Met Zichtb Verwond",
      "Zon. Zichtb Verwond"
    ]
  },
  "Braken": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Brancherichtl_Ovschr": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Brw_in_nood": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Inwerkingtreden noodprocedure in verband met in nood verkerende collega van een van de hulpverleningsdiensten.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Brandweer algemeen",
      "Brandweer duikinzet",
      "BRV",
      "IBGS"
    ]
  },
  "Burgeralarmering": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Burgers worden gewaarschuwd of gealarmeerd.",
    criterion_of_action: "Alarmering van burgers die bevoegd zijn AED toe te passen.",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "AED",
      "AED geannuleerd",
      "AED geen inzet",
      "Amberalert",
      "Burgernet",
      "Facebook",
      "NL alert",
      "Sociale media",
      "Twitter",
      "WAS",
      "WhatsApp"
    ]
  },
  "Burgernet_actie_ID": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Cat._Br/GS_PAC_Meld": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "C1 Tech. Geverif",
      "C2 Handbrandmelder",
      "C3 2de melder",
      "C4 1e meld Bu Werkt",
      "C5 1e meld Bi Werkt",
      "C6 Onbetrouwbaar"
    ]
  },
  "CBRN-e": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Compl._Uitsch": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "CLU aangevraagd",
      "CLU uitgevoerd",
      "CLU test: uit",
      "CLU test: aan",
      "CLU einde"
    ]
  },
  "Contra_bellen": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Wordt uitgevoerd",
      "Is uitgevoerd",
      "Mislukt geen contact",
      "Mislukt geen info"
    ]
  },
  "Contra_Tel.nummer": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Delaycode_ambu": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "On hold",
      "Geen Ambu eenheid",
      "Verificatie melding",
      "Onduidelijke locatie",
      "Van andere Discipl",
      "Communicatieprobleem",
      "Capaciteitsprobl. MK",
      "Personeel",
      "Onderhoud/Reparatie",
      "Roosterfout",
      "Overloopmelding",
      "Geen HAP eenheid",
      "Systeemstoring"
    ]
  },
  "Delaycode_brw": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Onderbez. niet Uitg",
      "Onderbez. uitgerukt",
      "Geen eenheid",
      "Verificatie melding",
      "Onduidelijke locatie",
      "Van andere Discipl",
      "Communicatieprobleem",
      "Capaciteitsprobl. MK",
      "Overloopmelding",
      "Systeemstoring"
    ]
  },
  "Delaycode_pol": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Geen eenheid",
      "Verificatie melding",
      "Onduidelijke locatie",
      "Van andere Discipl",
      "Communicatieprobleem",
      "Capaciteitsprobl. MK",
      "Overloopmelding",
      "Systeemstoring"
    ]
  },
  "Directe_inzet_Ambu": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "eCall": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Automatisch",
      "Handmatig"
    ]
  },
  "Etage": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Explosie": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Ext.IZB_Brw_AGS": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_AL": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_BRV": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_DP-GW1": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_DP-GW3": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_DR": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_FR-B": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_GZD": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_HOVD-B": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_HV": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_HV-KR": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_HW": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_KW-02": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_KW-05": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_MSA": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_NBT": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_ON-QR": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_OR": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_OVD-B": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_QR": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_RV": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_SB": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_SI": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_TO-MKB": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_TS": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_TS4": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_TS6": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_TS-OPS": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_TST": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_TST-NB": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_TW": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_VK": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_VKT-NB": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Ext.IZB_Brw_WO": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "Getalskarakteristieken kan via de Web Service van buiten GMS aangegeven worden welke inzetbehoefte van een bepaalde voertuigsoort men vanuit de bron wenst in te vullen voor dit specifieke incident.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Gebr_geweldsmiddel": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Bereden",
      "Boeien",
      "CS-Traangas",
      "Diensthond",
      "Elektr wapenstok",
      "Fysiek geweld",
      "Pepperspray",
      "Spijkermat",
      "Stroomstootwapen",
      "Vuurwapen",
      "Waterwerper",
      "Wapenstok kort",
      "Wapenstok lang"
    ]
  },
  Gesignaleerd: {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Gev.stof_naam": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Gevaar_buiten_inr.": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Gevaar_hulpverleners": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Gewonde_/_Zieken": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "1",
      "Meerdere"
    ]
  },
  "GRIP": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Multidisciplinaire opschaling KAR waarmee het GRIP niveau wordt aangegeven.",
    criterion_of_action: "Dag dagelijkse situatie. Coordinatie in het veld tussen de operationele diensten op basis van motorkapoverleg tussen hoogst leidinggevenden ter plaatse.",
    description_value: "GRIP 0 wordt vooral gebruikt als indicatie dat na een hoger GRIP niveau weer afgeschaald wordt naar de dagelijkse situatie.",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "2 zonder CoPI",
      "3 zonder CoPI",
      "4 zonder CoPI",
      "1 stil alarm",
      "2 stil alarm",
      "3 stil alarm",
      "4 stil alarm",
      "5 stil alarm",
      "2 stil Al Zon CoPI",
      "3 stil Al Zon CoPI",
      "4 stil Al Zon CoPI"
    ]
  },
  "Heterdaad": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Is er sprake van een heterdaad situatie?",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Hoog_energetisch": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Hoogwater_alarm": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "Hier en daar zijn waterstanden/afvoeren verhoogd of valt veel neerslag. Waterbeheerders nemen standaard-maatregelen om het eigen beheergebied te beschermen tegen het water. Gebruiksfuncties op en aan het water, zoals scheepvaart en activiteiten in uiterwaarden kunnen worden beperkt. Kleurcode geel (of hoger) kan ook worden afgegeven in geval van terreurdreiging en/of een (dreigende) cyberaanval. Kleurcode geel komt meerdere keren per jaar voor.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "Stond hgwgrn",
    answer_options: [
      "Niveau 1 code geel",
      "Niveau 2 code oranje",
      "Niveau 3 code rood"
    ]
  },
  "Hulpverlener_gewond": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ambulancezorg",
      "Brandweer",
      "Politie"
    ]
  },
  "Incident_meester": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Incidentmanagement": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Personenautos",
      "Vrachtautos",
      "Algemeen"
    ]
  },
  "Instantie": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Een bedrijf/instelling die ingezet kan worden bij een incident.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "AID",
      "Arbeidsinspectie",
      "Bouw & Woningtoez",
      "Brugwachter",
      "Busmaatschappij",
      "Cameratoezicht",
      "CMV",
      "DARES",
      "Dierenambulance",
      "Dierenarts",
      "Douane",
      "Electriciteitsbedr.",
      "EOD",
      "Gasbedrijf",
      "Gemeente",
      "Gemeentewerken",
      "Gladheidsdienst",
      "Glasbedrijf",
      "Handhaving",
      "Havenmeester",
      "Jachtopzichter",
      "LCM",
      "Loonbedrijf",
      "Meldkamer NS",
      "Metromaatschappij",
      "Natuurbeheer",
      "NRK",
      "NRK BES",
      "NVWA",
      "Omgevingsdienst",
      "Openbare verlichting",
      "Pechhulp",
      "Politieberger",
      "Postmortale Zorg",
      "ProRail",
      "Provincie",
      "RIVM",
      "Salvage",
      "Slachtofferhulp",
      "Sleutelhouder",
      "Sloopbedrijf",
      "Slotbedrijf",
      "Spoormaatschappij",
      "Stadstoezicht",
      "Trammaatschappij",
      "VBV",
      "VCNL",
      "Veerboot / Veerpont",
      "Verkeerscentrale RWS",
      "Verkeerslichten",
      "Verlofhouder",
      "Waterbedrijf",
      "Waterschap",
      "Woningbouw"
    ]
  },
  "Intern_MK": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Intrekken_alarm_Brw": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Inzet_Ambu": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Achterwacht MKA",
      "Achterwacht RAV",
      "AED",
      "Ambu",
      "Amheli",
      "B-rit Ambu",
      "B-rit bewaakt",
      "B-rit zorg",
      "GGZ",
      "HAP",
      "HART",
      "High Care",
      "Huisarts",
      "Intensive Care",
      "KMHG",
      "Leiding HART",
      "Low Care",
      "Medium Care",
      "MICU",
      "MMA",
      "MMT",
      "NICU",
      "PAA-VSA",
      "PICU",
      "Piket ICT RAV",
      "Psycholance",
      "Rapid",
      "Rolstoeltaxi",
      "TCOA",
      "Thuiszorg",
      "Verloskundige",
      "Verpleegkundig spec",
      "ZorgAmbu"
    ]
  },
  "Inzet_Brw_Alg": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "KAR waarmee een bepaalde inzet van de brandweer gevraagd kan worden zonder dat in eerste instantie sprake is van een voor de brandweer bestemde meldingsclassificatie. De inzet wordt gemaximeerd. ",
    criterion_of_action: "Inzet op verzoek CPA/MKA van(klein)snel inzetbaar brandweer team met AED.",
    description_value: "In diverse regio's/plaatsen kan de brandweer (kleine) snel inzetbare teams ter beschikking stellen met een AED daar waar een ambu vaak pas na langere tijd ter plaatse kan zijn.",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "AED",
      "Afhijsen",
      "Afhijsen stuurlijnen",
      "Aflossing",
      "Bedrijfsbrandweer",
      "Bergen slachtoffer",
      "Complexe gebouwen",
      "Daklijnenset",
      "Deur openen",
      "First Responder",
      "Herbezetting",
      "Herbezetting duikers",
      "Herbez. specialisme",
      "Hoogbouw",
      "Inzet Geinfec Geb",
      "Inzet op gr hoogte",
      "Kazerneren",
      "Medische Assistentie",
      "Nee",
      "Opst. Lokaal Afhand",
      "Patientverv. Ruw Ter",
      "Postalarm",
      "Quick Response Team",
      "Reinigen wegdek",
      "Slagkracht",
      "Tilassistentie"
    ]
  },
  "Inzet_Brw_Alg_EH": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "AL",
      "BRM",
      "HW",
      "RV",
      "SI",
      "Telescoopkraan",
      "TS",
      "TS-4",
      "TS-6",
      "TST",
      "TS4=TS6"
    ]
  },
  "Inzet_Brw_CO&VB": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "COH / MCU",
      "COH-Brandweer",
      "Land. Actiecent. Brw",
      "VC",
      "VD-MOB Opstel C2000",
      "VKL-DR / VK Drone"
    ]
  },
  "Inzet_Brw_functie": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Adv. Gev.stof",
      "Adv. Gev.stof ROT",
      "Alg. Cdt Brandweer",
      "Bevelv. van Dienst",
      "Commandant v. Dienst",
      "Compagnies Cdt",
      "Controleur preventie",
      "Coord. Lok Afhandel",
      "Coord. TCO",
      "Coord. Uitgangstel.",
      "Coord. Verkenning eh",
      "Duikadviseur",
      "Funct. Logistiek",
      "Gezagvoerder drone",
      "Hfd bron- en emissie",
      "Hfd informatie",
      "Hfd ondersteuning",
      "Hfd Off. v. Dienst",
      "Hfd Off. v. Dst grp",
      "Kazernecoordinator",
      "Landelijk Adv. NB",
      "Landelijk Adv. TDV",
      "Off. van Dienst",
      "Off. van Dienst grp",
      "PC Grootsch. Ontsm.",
      "PC Grootsch.water",
      "PC Grootsch.water NB",
      "PC IBGS",
      "PC Logistiek",
      "PC Natuurbrand",
      "PC Redding en THV",
      "PC Scheepsbrand",
      "PC Spec. Blussing",
      "Pelotons Cdt",
      "Regionaal adv. NB",
      "Taakcommandant",
      "Teamleider handcrew",
      "Teamleider QR",
      "Teamleider STH",
      "Teamleider TDV",
      "Voorlichter Brw"
    ]
  },
  "Inzet_Brw_HV_EH": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "HV",
      "HV-KR",
      "IJsslee",
      "Rampterrein Verl.",
      "Reddingskussen",
      "Redteam Hoogte",
      "Veetakel Inst.",
      "Verlichting",
      "VHT 25kV",
      "VHT Laagspanning"
    ]
  },
  "Inzet_Brw_IBGS": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Basis Ontsm.eh.",
      "Chemiepakteam",
      "Gaspakteam",
      "Gev.stof eenheid",
      "Gev.stof spec. eh.",
      "Gierpakteam",
      "Grootsch. Ontsm. eh",
      "Meting",
      "Milieuvoertuig",
      "Olieschermen",
      "Opstart verk. org."
    ]
  },
  "Inzet_Brw_Log_&_OnS": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Adembescherming",
      "Arbeidshygiene",
      "Begr. Bijs. Team",
      "Brandstoftank",
      "HA",
      "HAT",
      "Koelstoel",
      "Onderst.Team Brw",
      "Slang Opneemapparaat",
      "Stroom Aggregaat",
      "Team Brandonderzoek",
      "Team Coll.Opvang Brw",
      "Technische dienst",
      "Tent",
      "Verzorging",
      "Verzorging kantine",
      "Verzorging WC",
      "Zichtscherm"
    ]
  },
  "Inzet_Brw_NBB": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "KAR waarmee een bepaalde inzet van de brandweer gevraagd kan worden zonder dat in eerste instantie sprake is van een voor de brandweer bestemde meldingsclassificatie. De inzet wordt gemaximeerd. ",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Blusheli",
      "Bronpomp/buispomp",
      "Hand Crew NB",
      "Luchtsurv. start",
      "Luchtsurv. stop",
      "NBT",
      "TST-NB",
      "VK-NB",
      "Waterbassin",
      "Watertank NB"
    ]
  },
  "Inzet_Brw_op_Wat/WO": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "KAR waarmee een bepaalde inzet van de brandweer gevraagd kan worden zonder dat in eerste instantie sprake is van een voor de brandweer bestemde meldingsclassificatie. De inzet wordt gemaximeerd. ",
    criterion_of_action: "Inzet Brw duikers ter assistentie bij het bergen van een object uit het water. Meestal op verzoek van de andere disciplines of derden.",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Bergen object WO",
      "Bergen slachtoff WO",
      "BRV",
      "BRV Blusboot",
      "BRV Groot water",
      "BRV Patient vervoer",
      "MIRG Vooralarm",
      "MIRG Transport",
      "MIRG Einde",
      "Oppervlakte redteam",
      "ScheepsBr.Best. eh.",
      "WO",
      "WOV"
    ]
  },
  "Inzet_Brw_Spec_Blus": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "AS Industr.brand",
      "Bijzondere blusmidd.",
      "Blusrobot",
      "CrashTender",
      "Drukluchtschuim",
      "PB / PBH",
      "PBA",
      "Rietdakteam",
      "SB / SBH",
      "SBA",
      "Schuimvormend mid.",
      "TS Industr.brand",
      "Ultra hoge druk syst",
      "Ventilator",
      "Waterkanon",
      "Waterscherm"
    ]
  },
  "Inzet_Brw_Spec_Verk.": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "Op afstand bestuurde vliegende drone die binnen in bouwwerken, grot e.a. ruimtes ingezet kan worden.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Drone binnen",
      "Drone buiten",
      "Drone buiten groot",
      "Drone onderwater",
      "Sonar",
      "Team Digitale Verk.",
      "Verkenningsrobot"
    ]
  },
  "Inzet_Brw_water_win": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "GW 1500",
      "GW 3000",
      "GW M1500",
      "GW Z3000",
      "GW G1500",
      "GW Z1500",
      "GW G3000",
      "KW 200",
      "KW 500",
      "DP",
      "MSA",
      "MSA-G",
      "Peloton watertank",
      "SL",
      "Watertank",
      "SLH-3KM",
      "WTS1000",
      "WTS2500",
      "WTS4000"
    ]
  },
  "Inzet_GGB": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "GGB",
      "GGB Container",
      "Noodhulp Rode Kruis"
    ]
  },
  "Inzet_GGD": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Forensische arts",
      "Arts infectieziekten",
      "Calamiteitenteam",
      "Crisiscoordinator",
      "Crisisdienst GGD",
      "Procesleider GOR",
      "Procesleider IZB",
      "Procesleider jeugd",
      "Procesleider MMK",
      "Procesleider PSH",
      "Microbioloog",
      "Vpl infectie ziekte",
      "Com. Adviseur GGD",
      "Informatie Coord."
    ]
  },
  "Inzet_GGZ": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Crisisdienst GGZ"
    ]
  },
  "Inzet_GHOR_functie": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "OVDG",
      "HOVDG",
      "Dir PG",
      "TV transport",
      "PSHOR",
      "GAGS",
      "AC GZ",
      "HIN GZ",
      "HON GZ",
      "Piket GHOR"
    ]
  },
  "Inzet_GMK": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "GMK CaCo",
      "GMK Hoofd meldkamer",
      "GMK Lokaalbeheer",
      "MKA CTL-A",
      "MKB C-MKB",
      "MKB CTL-B",
      "MKB CTL-BG",
      "MKB CTL-VE",
      "MKB HMK-B",
      "MKB TOA",
      "MKP generalist",
      "MKP OpCo",
      "MKP OVD-OC",
      "MKP sectorhoofd",
      "MKP teamchef"
    ]
  },
  "Inzet_MO_functie": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Burgemeester",
      "OVD-Bevolkingszorg",
      "OVD-Water",
      "L-CoPI",
      "IM-CoPI",
      "GIM-CoPI",
      "ROL",
      "IM-ROT",
      "GIM-ROT",
      "AC-Bevolkingszorg",
      "AC-Crisis Communica",
      "AC-Ondersteuning",
      "Sectie Bevolkingsz",
      "Sectie Brandweer",
      "Sectie Crisis Comm",
      "Sectie Geneeskundig",
      "Sectie IM",
      "Sectie Ondersteuning",
      "Sectie Politie",
      "Kern-ROT",
      "Kern-ROT stil alarm",
      "ROT",
      "ROT stil alarm",
      "GBT",
      "GBT-stil alarm",
      "RBT",
      "RBT stil alarm",
      "Coord.team waddeneil",
      "Coord.team op water",
      "HIN-BZ",
      "HON-BZ",
      "Reg mil opr adv",
      "Voorzitter VR"
    ]
  },
  "Inzet_NRV": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "Landelijke functionaris (24/7 bereikbaarheid) voor vragen over en inzet NRV. Deze is het 1e aanspreekpunt voor de coördinerend meldkamer Noord-Holland.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Alg. Cdt NRV",
      "Land. Actiecent. NRV",
      "Landelijk coord. NRV",
      "NRV Pel Mid en Noord",
      "NRV Pel Noord-West",
      "NRV Pel Oost",
      "NRV Pel Zuid",
      "NRV Pel Zuid-West",
      "Off. van Dienst NRV",
      "Reddingsgroep",
      "Reg. Coord. RB"
    ]
  },
  "Inzet_Pol_algemeen": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Aanrijdingselecteur",
      "AED",
      "Arrestantenvervoer",
      "Bewaken & Beveiligen",
      "Cameratoezicht",
      "Dienst logistiek",
      "Executietaken",
      "Familieagent",
      "Hennepteam",
      "HOVD",
      "HOVJ",
      "HOVJ-huisverbod",
      "IBT",
      "Leiding Reg eenheid",
      "ME",
      "Onderhandelaar",
      "OpCo",
      "OVD-I",
      "OVD-OC",
      "OVD-P",
      "OVD-V",
      "OVJ",
      "OVP",
      "PD-unit",
      "Persvoorlichting",
      "RCCB",
      "RSC",
      "Surveillancehond",
      "TCI",
      "TCO",
      "Team paraatheid",
      "TOOI",
      "TVS",
      "Vaartuig groot",
      "Vaartuig klein",
      "Verkeerstechn. Begel",
      "Verlichtingsunit",
      "Vervoer Beslaghuis",
      "VIK",
      "Voertuig berger",
      "Voetbaleenheid",
      "VTT",
      "Waterscooter",
      "WWM",
      "Zeehavenpolitie"
    ]
  },
  "Inzet_Pol_functie": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "AC",
      "Districtschef",
      "Korpschef",
      "Politiechef",
      "Sectorhoofd DROC",
      "Teamchef"
    ]
  },
  "Inzet_Pol_landelijk": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "AOT",
      "Beredenen",
      "DKDB",
      "DSI QRF",
      "DSI RRT",
      "DSI UIM",
      "ExpTeam Visu - Recon",
      "FAST",
      "Heli",
      "LFO",
      "LOCC",
      "LTFO",
      "LTOZ",
      "Luchtvaarttoezicht",
      "OG-AE",
      "OT",
      "Reddingshond",
      "Rijksrecherche",
      "Speurhond",
      "Team Transport"
    ]
  },
  "Inzet_Pol_recherche": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "AVIM",
      "Digitale expertise",
      "DR",
      "DRR",
      "Familierechercheur",
      "FO",
      "Inlichtingendienst",
      "Interceptie",
      "IRC",
      "LPD",
      "Narcotica",
      "OVD-R",
      "Tactische opsporing",
      "Team Bedr politici",
      "Team Bijz opsporing",
      "Team overvallen",
      "TEV",
      "TGO",
      "VAT",
      "VOA",
      "VVC",
      "Zeden"
    ]
  },
  "Inzet_Pol_SGBO": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "SGBO opstarten",
      "HBB",
      "HHN",
      "HIN",
      "HINT",
      "HMOB",
      "HOHA",
      "HON",
      "HOPEX",
      "HOPS"
    ]
  },
  "Inzet_SAR": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "KWC",
      "Lifeguards KNRM",
      "First Responder",
      "RedBrig. Strandw",
      "Reddingsbrigade",
      "Reddingboot KNRM",
      "RedBoot. PatientVerv",
      "Schipper van Dienst",
      "Strandtransport",
      "Kust HV truck KNRM",
      "SAR heli",
      "HVH-SAM/SAMIJ bak",
      "SAMIJ Regeling",
      "Nautische arts"
    ]
  },
  "Justitiele_Voorw": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Kenteken": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Kenteken_DEFlog": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Kleur_patient": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Blauw",
      "Bleek",
      "Grauw",
      "Normaal",
      "Rood"
    ]
  },
  "Kraken": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "LCM-Nummer": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Leeftijd": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Lijkvinding": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Het aantreffen van een lijk waarvan de identiteit niet direct kan worden vastgesteld en de doodsoorzaak vraagt om nader onderzoek.",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Live_View": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Loc._in_vaartuig": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Accommodatie",
      "Lading",
      "Machinekamer"
    ]
  },
  "Locatie_ongeval": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Bedrijf",
      "Huis",
      "Sport"
    ]
  },
  "Lokaal_afhandelen": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Lokmiddel": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "LVO_categorie": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "Aantal personen in luchtvaartuig is 1 t/m 3",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Zeer klein",
      "Klein",
      "Middel",
      "Groot",
      "Zeer groot"
    ]
  },
  "Medisch_hulpmiddel": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Brancard",
      "Monitor",
      "Zuurstofcilinder",
      "Perfusorpomp",
      "Maxi cosi",
      "Couveuse"
    ]
  },
  "Meldcode": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "<regionaal invullen>"
    ]
  },
  "Meldercontact": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Buiten tijd",
      "Geen gehoor",
      "Geen telefoon",
      "Niet bellen",
      "Niet gebeld",
      "Teruggebeld",
      "Wil niet",
      "Vervallen",
      "PCC",
      "Niet terugbellen",
      "+30 min teruggebeld",
      "+60 min teruggebeld",
      "Geen inzet nodig",
      "+30 min geen contact",
      "+60 min geen contact",
      "Doorverwezen",
      "Doorgezet BT",
      "+120 min doorgezet",
      "Terugbellen 30 min",
      "Terugbellen 60 min"
    ]
  },
  "Met_brand": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Kar. om bij b.v. een incident wat primair als ongeval aangeduid wordt, aan te geven dat er ook brand is.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Met_gevaarlijke_stof": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Als bij een incident wat niet primair een incident is met gevaarlijke stoffen er wel gevaarlijke stoffen worden aangetroffen die (mogelijk) van invloed kunnen zijn/worden op het effect en de bestrijding van het incident.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Met_ongeval": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Met_WO": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meteogegevens": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Militair_betrokken": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "MoIP_intern_afgehand": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "MoIP_status_melding": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "KAR waarde om de status van een MoIP melder weer te geven",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Actief",
      "In onderhoud",
      "Passief"
    ]
  },
  "MoIP_toest._melding": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "KAR waarde om de toestand van een MoIP melder weer te geven",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Alarm",
      "Rust"
    ]
  },
  "NB_uitbreid._risico": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "KAR waarde die risico op snelle uitbreiding van branden in begroeiing aangeeft bij toenemende droogte.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Laag",
      "Normaal",
      "Hoog",
      "Zeer hoog"
    ]
  },
  "NMR": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Nationale Meetnet Radioactiviteit Melding",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "OMS/PAC_oorzaak": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Brand",
      "Brand reeds geblust",
      "Afwijkend gebruik",
      "Ontwerpfout",
      "Niet te achterhalen",
      "Brandstichting",
      "Roken",
      "Bakken/Braden e.d.",
      "Flamberen",
      "Uitlaatgassen",
      "Las-/Slijpwerkz.",
      "Soldeerwerkzaamheden",
      "Aerosolen uit Prod",
      "Opzettelijk Geactiv",
      "Bedieningsfout",
      "Stoom/Douche/Koken",
      "Vervuilde melder",
      "Opwervelend stof",
      "Lijmwerkzaamheden",
      "Beschadiging",
      "Atmosferische Invl",
      "Systeemstoring/EMC",
      "Werkzaamheden",
      "OMS-Infrastructuur",
      "Overige/Anders"
    ]
  },
  "OMS/PAC_Toel": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Omstandigh._pijn": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Bij beweging",
      "Spontaan"
    ]
  },
  "Onder_invloed_van": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Alcohol",
      "Drugs",
      "Medicijnen",
      "Onbekend"
    ]
  },
  "Onderdeel_agr._bedr.": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Brandstofopslag",
      "Chemicalienopslag",
      "Gier-/Drijfmestopsl",
      "Kas",
      "Koelcel",
      "Kunstmestopslag",
      "Machineberging",
      "Productbewerking",
      "Productopslag",
      "Stal",
      "Voeropslag"
    ]
  },
  "Onderdeel_gebouw": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Balkon",
      "Berging/Garage",
      "Dak",
      "Hoogspanningsruimte",
      "Kelder/Souterrain",
      "Keuken",
      "Laboratorium",
      "Meterkast",
      "Parkeergarage",
      "Rietendak",
      "Schoorsteen",
      "Trappenhuis",
      "Zolder"
    ]
  },
  "Ondergronds": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Ontruiming": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "Ontruiming is het voor korte duur verlaten van de verblijfplaats op een advies van parate diensten. Brandweer en politie kunnen direct tot een dergelijk advies overgaan, indien daarvoor, binnen aan te geven grenzen, een mandaat is versterkt.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Openlijk_geweld": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Ops_Ambu": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Code 5",
      "Code 10",
      "Code 20",
      "Code 30",
      "Code 40",
      "Code 50"
    ]
  },
  "Ops_Bijstand_GBO": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Intern MK gebied",
      "Vragen",
      "Verlenen"
    ]
  },
  "Ops_Br": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Standaard brandbestrijding opschaling brandweer.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Klein",
      "Middel",
      "Groot",
      "Zeer groot"
    ]
  },
  "Ops_GBO_Basis_Pel": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor inzet in eigen regio",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. Basis",
      "2 Pel. Basis",
      "3 Pel. Basis",
      "4 Pel. Basis"
    ]
  },
  "Ops_GBO_GW": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor inzet in eigen regio",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. GW G3000",
      "2 Pel. GW G3000"
    ]
  },
  "Ops_GBO_HV": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor inzet in eigen regio",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. Redding & THV",
      "2 Pel. Redding & THV",
      "3 Pel. Redding & THV",
      "4 Pel. Redding & THV",
      "STH",
      "SHH-ST / Stut-stemp.",
      "USAR binnenland",
      "USAR buitenland"
    ]
  },
  "Ops_GBO_IBGS": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor inzet in eigen regio",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. IBGS",
      "2 Pel. IBGS",
      "3 Pel. IBGS",
      "4 Pel. IBGS",
      "1 Spec. Pel. IBGS",
      "2 Spec. Pel. IBGS"
    ]
  },
  "Ops_GBO_IV": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor inzet in eigen regio",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. IV"
    ]
  },
  "Ops_GBO_Log_en_OnS": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor inzet in eigen regio",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. Log & Ons",
      "2 Pel. Log & Ons"
    ]
  },
  "Ops_GBO_NBB": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor inzet in eigen regio",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "Stond NBBS",
    answer_options: [
      "1 Pel. NatBr Bestr",
      "2 Pel. NatBr Bestr",
      "3 Pel. NatBr Bestr",
      "4 Pel. NatBr Bestr",
      "5 Pel. NatBr Bestr",
      "6 Pel. NatBr Bestr",
      "1 Pel GW NatBr Bestr",
      "2 Pel GW NatBr Bestr",
      "1 Pel DF NatBr Bestr"
    ]
  },
  "Ops_GBO_SBB": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor inzet in eigen regio",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. SBB",
      "2 Pel. SBB",
      "3 Pel. SBB",
      "4 Pel. SBB"
    ]
  },
  "Ops_GBO_Spec.Bl.": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "Gebruik voor inzet in eigen regio",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "1 Pel. Schuim",
      "2 Pel. Schuim",
      "1 Pel. Tank brand",
      "2 Pel. Tank brand",
      "1 Pel. Tankput brand",
      "2 Pel. Tankput brand"
    ]
  },
  "Ops_HV": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Standaard hulpverlening door opschaling brandweer.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Klein",
      "Middel",
      "Groot",
      "Zeer groot"
    ]
  },
  "Ops_IBGS": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Opschaling van een ongeval met gevaarlijke stoffen.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Klein",
      "Middel",
      "Groot",
      "Zeer groot"
    ]
  },
  "Ops_LVO": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Klein",
      "Middel",
      "Groot",
      "Zeer groot"
    ]
  },
  "Ops_MK": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "MKA",
      "MKP",
      "MKB",
      "Piket leiding MK"
    ]
  },
  "Ops_WO": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Opschaling van brandweerduiken bij waterongevallen.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Klein",
      "Middel",
      "Groot",
      "Zeer groot"
    ]
  },
  "Opsp.middel.": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Mobeye",
      "LokAuto",
      "LokFiets"
    ]
  },
  "Optisch_&_geluidsign": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ambulancezorg",
      "Brandweer",
      "Politie"
    ]
  },
  "Opzettelijk": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Persalarmering": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Personeelsnummer": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Persoon_hoog/diep": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Hoogte",
      "Diepte"
    ]
  },
  "Persoon_in_brand": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Planscenario": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Bleve",
      "Blow Out",
      "Dreigende Bleve",
      "Emissie",
      "Fakkelbrand",
      "PGS opslag",
      "Plasbrand",
      "Toxische plasverdamp"
    ]
  },
  "Pol_in_nood": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Inwerkingtreden noodprocedure in verband met in nood verkerende collega van een van de hulpverleningsdiensten.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Potloodventer": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Probl._schip/Watersp": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Aan grond gelopen",
      "Aan lagerwal",
      "Duiker",
      "Gekapseisd",
      "Gezonken schip",
      "Kapot tuigage",
      "Lek/Zinkend",
      "Motorpech",
      "Onzeker van positie",
      "Schip Verm/Overtijd",
      "Slagzij",
      "Stuurloos/Op drift",
      "Surfuitrust. Gevond",
      "Watersporter probl.",
      "Watersporter vermist"
    ]
  },
  "Procedure_Ambu": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "<landelijk invullen>"
    ]
  },
  "Procedure_Brw": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "<landelijk invullen>"
    ]
  },
  "Procedure_Multi": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "<landelijk invullen>"
    ]
  },
  "Procedure_Pol": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Amok",
      "BTGV",
      "INRAP",
      "Manhunt scenario 1A",
      "Manhunt scenario 1B",
      "Manhunt scenario 2A",
      "Manhunt scenario 2B"
    ]
  },
  "Ramp_op_afstand": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "Een luchtvaartuig crasht op weg naar of op weg van luchthaven en de regio van die luchthaven moet daardoor processen op starten",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Reinigen_van": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Aangeven welke dienst opgroepen wordt om te reinigen. Alleen de Brw. kiezen indien er een dermate gevaarlijke situatie is ontstaan als het ter plaatse krijgen van andere diensten te veel tijd kost. Dit tenzij het een gemeentelijke weg betreft in gemeente ",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Gemeente weg",
      "Provinciale weg",
      "Rijksweg",
      "Spoor/Trein"
    ]
  },
  "RTIC": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Vraagt",
      "Zoekt",
      "Klaar",
      "Info",
      "Nee",
      "Wacht",
      "Geen relevante info",
      "Stopt",
      "OC Vraagt"
    ]
  },
  "Scen._Ext_partner": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Schietterrein_actief": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Signalement_persoon": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Sleutelhouder_komt": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Soort_Aanr_spoor": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ontsporing",
      "Hard koppelen",
      "Gekanteld/Vervormd",
      "Rangeerdelen",
      "Passagierstrein",
      "Goederentrein",
      "Light Rail",
      "Tram",
      "Metro",
      "Zwaar voertuig",
      "Klein voertuig",
      "Persoon",
      "Persoon overleden",
      "Dier",
      "Object"
    ]
  },
  "Soort_Aanr_weg": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Aanrijding",
      "Auto",
      "Auto-auto",
      "Bus",
      "Dubbeldekkerbus",
      "Vrachtauto",
      "Tankauto",
      "Zwaar voertuig",
      "Motor",
      "Bromfiets",
      "Fiets",
      "Persoon",
      "Boom",
      "Gebouw",
      "Object",
      "Eenzijdig",
      "Gekanteld/Op de kop",
      "Meervoudig",
      "Dier"
    ]
  },
  "Soort_aantreffen": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Dier",
      "Fiscale wanbetaler",
      "Gestolen voertuig",
      "Goed",
      "Vaartuig",
      "Voertuig",
      "Wapen",
      "Aangespoeld",
      "In het water"
    ]
  },
  "Soort_aanvaring": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Beroepsvaart",
      "Recr-/Pleziervaart",
      "Zwemmer/Duiker",
      "Object/Wal",
      "Meervoudig"
    ]
  },
  "Soort_afstemverzoek": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "waarden lokaal invullen",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "<landelijk invullen>"
    ]
  },
  "Soort_afval": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Asbest",
      "Chemisch",
      "Drugslab",
      "Huisvuil",
      "Mest",
      "Wietplantage"
    ]
  },
  "Soort_alarm": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "INS proefalarm",
      "NL Alert proefalarm",
      "Noodalarm",
      "P2000 proefalarm",
      "Semafonie proefalarm",
      "WAS luid proefalarm",
      "WAS stil proefalarm"
    ]
  },
  "Soort_alert": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Land",
      "Lucht",
      "Zee",
      "Quick Alert"
    ]
  },
  "Soort_ANPR": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "A86",
      "A87",
      "A87 vrachtauto",
      "Aandachtvestiging",
      "Ad hoc",
      "Katvanger",
      "Mobiel banditisme",
      "Openbare orde",
      "OPS",
      "OPS+",
      "Rij-ontzeggingen"
    ]
  },
  "Soort_begeleiden": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ambulance",
      "VIP",
      "Vreemdeling",
      "Waardetransport",
      "Nucleair"
    ]
  },
  "Soort_beveiliging": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Object",
      "Persoon",
      "PD",
      "Waardetransport"
    ]
  },
  "Soort_Bijeenk_geb": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Bioscoop",
      "Discotheek",
      "Kerk",
      "Kinderdagverblijf",
      "Moskee",
      "Museum",
      "Synagoge",
      "Theater"
    ]
  },
  "Soort_bijgebouw": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Afdak/Carport",
      "Fietsenhok",
      "Garagebox",
      "Kas",
      "Keet/Hok/Schuurtje",
      "Loods/Grote schuur",
      "Stal",
      "Tuinhuis",
      "Elektrakast",
      "Elektriciteitsopslag",
      "Hooi-/stro-opslag",
      "Gier-/Drijfmestkeld.",
      "Windturbine",
      "Zendmast"
    ]
  },
  "Soort_bom/explosief": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Brandbom",
      "CBRN bom",
      "Crofty-Bom",
      "Explosieve Bom",
      "Explosieve stof",
      "Handgranaat",
      "IED/Geimpr. Expl",
      "Mijn",
      "Onbekend"
    ]
  },
  "Soort_bos": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Loofbos",
      "Naaldbos"
    ]
  },
  "Soort_Br_Beheerssyst": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "Waarde ook onder Soort detectie",
    answer_options: [
      "Gasblussysteem",
      "Rook en warmte Afv",
      "Schuimblussysteem",
      "Sprinkler",
      "Watermist"
    ]
  },
  "Soort_Buit_Br_Indus": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Buitenopslag",
      "Machine/Installatie",
      "Opsl. Brand Vloeis",
      "Silo",
      "Tank",
      "Tankput"
    ]
  },
  "Soort_container": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Afvalcontainer",
      "Bouwcontainer",
      "Glasbak",
      "Kledingcontainer",
      "Papiercontainer"
    ]
  },
  "Soort_detectie": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "Detector waarmee aangegeven kan worden dat brand/GS incident beheer systeem in werking is getreden maar er kan nog niet aangegeven worden welk soort beheersysteem het betreft.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Beheerssysteem",
      "Drukknop",
      "Gasblussysteem",
      "Gevaarlijke stof",
      "Hand",
      "Rook/Hitte",
      "Rook en warmte Afv",
      "Schuimblussysteem",
      "Sprinkler",
      "Watermist",
      "Onbekend"
    ]
  },
  "Soort_dienst_aan_3en": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Bewoner geen gehoor",
      "Tilhulp",
      "Hulpverlening"
    ]
  },
  "Soort_dier": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Amfibie",
      "Huisdier",
      "Insecten",
      "Ongedierte",
      "Reptiel",
      "Vee",
      "Vis",
      "Vogel",
      "Wild",
      "Zeezoogdier"
    ]
  },
  "Soort_drugs": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Harddrugs",
      "Softdrugs"
    ]
  },
  "Soort_epidemie": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "BSE",
      "Ebola",
      "MKZ",
      "Q-koorts",
      "Vogelgriep",
      "Infectieziekte klein",
      "Infectieziekte groot",
      "SARS-covid"
    ]
  },
  "Soort_fraude": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Computervredebreuk",
      "Identiteitsfraude",
      "Online fraude",
      "Phishing",
      "Skimmen",
      "Spam",
      "Vals document",
      "Vals geld",
      "Voorschotfraude"
    ]
  },
  "Soort_geplande_actie": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Aanhouding",
      "Affakkelen",
      "Begassing/Rookproef",
      "Begeleiden Demonstr",
      "Begeleiden evenement",
      "Bewaken",
      "Buurtonderzoek",
      "Controle",
      "Gas afblazen",
      "Helilanding",
      "Jagen",
      "Ontruimen/uitzetten",
      "Posten",
      "Proefalarm",
      "Stand-by",
      "Stookvergunning",
      "Systeemtest",
      "Verhoor",
      "Verkeerscontrole",
      "Zoeking"
    ]
  },
  "Soort_gevaar": {
    type: "Meervoudige opsom",
    quesiton_definition: "Een boom die gevaar oplevert in bepaalde situaties",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Boom",
      "Dak",
      "Elektrisch",
      "Gedrang",
      "Gevel",
      "Hek",
      "Los bouwdeel",
      "Los object",
      "Schoorsteen",
      "Steiger"
    ]
  },
  "Soort_geweld": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Agressie",
      "Extreem",
      "Fysiek",
      "Huiselijk geweld",
      "Tegen Ambu",
      "Tegen Brw",
      "Tegen LHBTI",
      "Tegen OV",
      "Tegen Pol",
      "Tegen taxi",
      "Verbaal"
    ]
  },
  "Soort_goed": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Soort_inbraak": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Plofkraak",
      "Ramkraak"
    ]
  },
  "Soort_industrie": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Chemisch",
      "Fabricage/Opslaggeb.",
      "Onderhoud/Reparatie",
      "Opsl. BrandB Vloeis",
      "Petrochemie"
    ]
  },
  "Soort_luchtvaartuig": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Drone",
      "Helikopter",
      "Luchtballon",
      "Militair",
      "Sportvliegtuig",
      "Straaljager",
      "Ultralight",
      "Passagiersvliegtuig",
      "Vrachtvliegtuig",
      "Zeppelin",
      "Zweefvliegtuig"
    ]
  },
  "Soort_melding": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "Opzettelijk zonder dat daartoe de noodzaak aanwezig is, gebruik maken van een alarmnummer voor publieke diensten.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Misbruik 112",
      "Valse melding"
    ]
  },
  "Soort_munitie": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Kogels",
      "Patronen",
      "Patroonhulzen",
      "Onbekend"
    ]
  },
  "Soort_Nucleair_Inc": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Storing",
      "Meld.Zonder Grip/Ops",
      "N Alert",
      "N Facility emergency",
      "N Sitearea emergency",
      "N General emergency",
      "B Alert",
      "B Facility emergency",
      "B Site area emerg.",
      "B General emergency",
      "B Gen. Em. Reflex m.",
      "D Em. standby_Voral",
      "D Plant em_Voralarm",
      "D Site em_Katast.al",
      "D Off site em_Kat.al"
    ]
  },
  "Soort_nuts": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Drinkwater",
      "Elektriciteit",
      "Gas",
      "Openbare verlichting",
      "Riolering",
      "Stadsverwarming",
      "Telefonie"
    ]
  },
  "Soort_oefening": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Algemeen",
      "CTER",
      "Duiken",
      "Met rook",
      "Oefenrit Opt Gel",
      "Ontruiming",
      "Vaartraining"
    ]
  },
  "Soort_ongeval": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Elektrocutie",
      "Instorting",
      "Val",
      "Verschuiving",
      "Verzakking"
    ]
  },
  "Soort_Openb_vervoer": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Bus",
      "Lightrail",
      "Metro",
      "Tram",
      "Trein",
      "Trolleybus",
      "Veerpont"
    ]
  },
  "Soort_overbrenging": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Arrestant",
      "Bericht",
      "Collega",
      "Getuige",
      "Gevangene",
      "Goederen",
      "MMT",
      "Persoon",
      "Verdachte",
      "Voertuig"
    ]
  },
  "Soort_overige_Geb": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Nutsbedrijf/Centrale",
      "Parkeergarage",
      "Schip-/Boothuis",
      "Station",
      "Tunnel"
    ]
  },
  "Soort_overlast": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Baldadigheid",
      "Bedelen",
      "Brandkranen",
      "Crossen",
      "Dronkenschap",
      "Drugsgebruik",
      "Drugsrunner",
      "Evenement",
      "Gluren",
      "Hijgen",
      "Hondenpoep",
      "Muziek",
      "Muzikanten",
      "Relationeel",
      "Rook",
      "Sneeuw/IJs",
      "Voetballen",
      "Vuur",
      "Zwerfafval",
      "Zwerver"
    ]
  },
  "Soort_pers._gericht": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Bedreiging",
      "Belediging",
      "Cyberpesten",
      "Discriminatie",
      "Smaad/laster",
      "Stalking/belaging",
      "Verspreiden media"
    ]
  },
  "Soort_persoon": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Baby",
      "Kind",
      "Jongen",
      "Meisje",
      "Volwassene",
      "Man",
      "Vrouw"
    ]
  },
  "Soort_plan_incident": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "CBP",
      "CIN",
      "IBP",
      "RBP"
    ]
  },
  "Soort_prostitutie": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Bordeelprostitutie",
      "Escortservice",
      "Hotelprostitutie",
      "Massagesalon",
      "Straatprostitutie"
    ]
  },
  "Soort_seksueel_benad": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "Grooming is digitaal kinderlokken. Er is sprake van grooming als een volwassene via ICT contact legt met een kind, met de intentie om dat kind te ontmoeten met het doel om seksueel misbruik te plegen of kinderpornografische afbeeldingen te produceren.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Grooming",
      "Sexchatting"
    ]
  },
  "Soort_Spec_inzet": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Bedrijf"
    ]
  },
  "Soort_spoorvervoer": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Goederentrein",
      "Lightrail",
      "Metro",
      "Passagierstrein",
      "Tram"
    ]
  },
  "Soort_standby-inzet": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Brand",
      "Evenement",
      "GRIP",
      "Oefening",
      "VIP",
      "Overig"
    ]
  },
  "Soort_stank/Hin_Luch": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Soort_stormschade": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Boom",
      "Hek/Bord/Steiger ed",
      "Los dak/geveldeel"
    ]
  },
  "Soort_Straatmeub": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "ABRI",
      "Brievenbus",
      "Flitspaal",
      "Laadpaal",
      "Lantaarnpaal",
      "Parkeerautomaat",
      "Spoor-/Slagboom",
      "Verkeersbord",
      "Verkeerslicht"
    ]
  },
  "Soort_stremming": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Afgevallen lading",
      "Brug sluit niet meer",
      "Gat in rijbaan",
      "Lekke waterleiding",
      "Obstakel op rijbaan",
      "Onbeheerd voertuig",
      "Overweg",
      "Pechgeval",
      "Verkeersregulatie",
      "Wegblokkade",
      "Werkzaamheden"
    ]
  },
  "Soort_terrorisme": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Er is sprake van terrorisme wanneer de Nationaal Coordinator Terrorismebestrijding dit heeft afgekondigd.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "CTER Sc1 dreiging",
      "CTER Sc2 Aansl klein",
      "CTER Sc3 Aansl groot",
      "CTER Sc4 op meer Loc",
      "CTER Sc5 Ondersteun"
    ]
  },
  "Soort_THV": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Mede op verzoek van de medische sector wordt de brandweer gevraagd onderscheid te maken tussen een situatie waarin een persoon daadwerkelijk BEKNELD zit en BEVRIJDING waarbij alleen een deur dak, of andere onderdelen opengemaakt of verwijderd moeten worden.",
    criterion_of_action: "THV met betrekking tot personenvoertuigen",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Licht",
      "Zwaar"
    ]
  },
  "Soort_vaartuig": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "De bruine vloot is de aanduiding voor de professionele passagiersvaart (chartervaart) met traditionele zeilschepen en motorschepen in Nederland.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Beroeps/bruine vloot",
      "Binnenvaartschip",
      "Cruiseschip",
      "Duw-/Sleepvaart",
      "Jetski",
      "Kano/Roeiboot",
      "Militair",
      "Offshore platform",
      "Partyboot",
      "Passagiersschip",
      "Recr-/Pleziervaart",
      "Rondvaartboot",
      "Surfplank/Kite",
      "Tanker",
      "Veerpont/Ferry",
      "Vrachtschip",
      "Zeeschip"
    ]
  },
  "Soort_vermissing": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Baby",
      "Dier",
      "Goed",
      "Jongen",
      "Kind",
      "Man",
      "Meisje",
      "Urgent",
      "Volwassene",
      "Vrouw"
    ]
  },
  "Soort_voertuig": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Aanhanger",
      "Bestelbus",
      "Bromfiets",
      "Brommobiel",
      "Bus",
      "Camper",
      "Caravan",
      "Dienstvoertuig",
      "Dubbeldekkerbus",
      "Fiets",
      "Land-/Bouwvoertuig",
      "Militair",
      "Motor",
      "Personenauto",
      "Quad",
      "Scooter",
      "Tankauto",
      "Taxi",
      "Vrachtauto",
      "Waardetransport"
    ]
  },
  "Soort_VVMD_brandstof": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Soort brandstof waar het voertuig op rijdt.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Alternatief",
      "Conventioneel",
      "Alcohol",
      "Benzine",
      "CG/Concentr. Gas",
      "CNG/Conc Nat. Gas",
      "Cryogenic",
      "Diesel",
      "Electrisch",
      "Gas",
      "Kerosine",
      "LNG/Natural gas",
      "LPG",
      "Stoom",
      "Waterstof",
      "Zware stookolie"
    ]
  },
  "Soort_wapen": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Nee",
      "Onbekend",
      "Slag-/Stootwapen",
      "Pepperspray",
      "Soort onbekend",
      "Steekwapen",
      "Vuurwapen",
      "Stroomstootwapen",
      "Luchtdrukwapen"
    ]
  },
  "Soort_weeralarm": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Gladheid",
      "Hitte",
      "Mist",
      "Koude",
      "Onweer",
      "Regen",
      "Sneeuw",
      "Water-/Windhozen",
      "Wind"
    ]
  },
  "Soort_woning": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Aanleunwoning",
      "Appartement",
      "Bovenwoning",
      "Chalet",
      "Duplexwoning",
      "Flat",
      "Hoekwoning",
      "Molen",
      "Portiekwoning",
      "Stacaravan",
      "Tussenwoning",
      "Vrijstaand",
      "Woonboerderij",
      "Woonboot",
      "Woonwagen"
    ]
  },
  "Soort_zelfdoding": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Chemisch",
      "Medicatie",
      "Mes",
      "Overdosis",
      "Springen",
      "Verbranding",
      "Verdrinking",
      "Vergassing",
      "Vergiftiging",
      "Verhanging",
      "Verstikking",
      "Vuurwapen"
    ]
  },
  "Soort_zorgafspraak": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Binnen 1 uur",
      "Binnen 2 uur",
      "In de ochtend",
      "In de middag",
      "In de avond",
      "In de nacht",
      "Op bepaald tijdstip",
      "Zodra beschikbaar",
      "Retour tijd nnb"
    ]
  },
  "Srt_Militaire_zaken": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "Een zaak die valt onder geheimhouding",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Geclas incident",
      "Inspectie",
      "Ongeoorloofd afwezig",
      "Speciale opdrachten",
      "Wachtdelict"
    ]
  },
  "Srt_Vreemdelingzaak": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "Aantreffen van een verstekeling.",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Aantref verstekeling",
      "Asielzaak",
      "Uitzetting"
    ]
  },
  "Suicidaal": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "T_1_Levensbedreigend": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "T_2_Zwaar_gewond": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "T_3_Licht_gewond": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "T_4_Dodelijk_gewond": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Tijd_1e_alarm": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Toestand_dier": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Dood",
      "Gewond",
      "Ziek"
    ]
  },
  "Transportleiding": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Het betreft zowel enkelvoudige transportleidingen, buisleidingen als leidingstraten.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Uitgaan/horeca": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Uitval_MK_systeem": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "C2000",
      "GIS",
      "GMS",
      "INS",
      "NL-Alert",
      "OMS",
      "P2000",
      "Telefonie",
      "WAS"
    ]
  },
  "UN_nummer": {
    type: "Vrije tekst",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: ""
  },
  "Verkenningseenheid": {
    type: "Getal",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "Hiermee wordt aangegeven hoeveel verkennningseenheden gealarmeerd moeten worden.",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: ""
  },
  "Verl._plaats_ongeval": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Verlamming": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Dubbelzijdig",
      "Eenzijdig",
      "Niet kunnen spreken",
      "Verward spreken"
    ]
  },
  "Verward_persoon": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Via_land_bereikbaar": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Vreemdelingen": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Vuurwerkslachtoffer": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Weercode": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Ja",
    comments: "",
    answer_options: [
      "Groen",
      "Geel",
      "Oranje",
      "Rood weeralarm"
    ]
  },
  "Wegsleepregeling": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "WI_afgehandeld": {
    type: "Meervoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "WI afgehandeld Ambu",
      "WI afgehandeld Brw",
      "WI afgehandeld Pol"
    ]
  },
  "Windrichting": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Noord",
      "Noordoost",
      "Noordwest",
      "Oost",
      "West",
      "Zuid",
      "Zuidoost",
      "Zuidwest"
    ]
  },
  "Zieke/dode_dieren": {
    type: "Enkelvoudige opsom",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Aangespoeld",
      "Berm",
      "In het water",
      "Particulier terrein",
      "Rijbaan",
      "Weiland"
    ]
  },
  "Zonnepanelen_Aanw": {
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    description_value: "",
    remarks: "Nee",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,,": {
    description_value: "Alarm,Alle soorten alarmen van detectiesystemen die rechtstreeks op de meldkamer binnenkomen, en meldingen door derden over het afgaan van alarmen van detectiesystemen.,Aangezien proefalarmen geen binnenkomende alarmen zijn vallen die niet onder deze MC. Het zijn geen incidenten/meldingen en zijn daarom niet opgenomen in de set.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Autom. brand,": {
    description_value: "Autom. brandmelding,Alarmen van aangesloten OMS die direct op de meldkamer binnenkomen en automatische brandmeldingen door PAC aan de meldkamer doorgegeven.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Autom. brand,Autom. brand OMS": {
    description_value: "OMS brandmelding,Melding via OMS van inwerkingtreding van een automatische brandmelder,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Autom. brand,Br beheerssysteem": {
    description_value: "OMS Br beheerssysteem,Melding via OMS van inwerkingtreding van een automatische blusinstallatie,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Autom. brand,Brandmelding PAC": {
    description_value: "PAC brandmelding,Binnenkomende brandmeldingen via de PAC van op PAC aangesloten automatische branddetectiesystemen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Autom. brand,Drukknopmelding OMS": {
    description_value: "OMS drukknopmelding,Melding via het OMS van een aangesloten handmelder in controle-/portiersruimtes van risicovolle objecten. Bediening mag uitsluitend door kundige medewerkers worden verricht. Dit zijn dan ook meldingen waaraan de hoogste urgentie moet worden gegeven voor afhandeling melding.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Autom. brand,Handmelder OMS": {
    description_value: "OMS handmelder,Brandmeldingen op de meldkamer die direct binnenkomen via de aangesloten OMS, en automatische brandmeldingen via de PAC aan de meldkamer doorgegeven.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Autom. Gev stof,": {
    description_value: "Autom. gev. stofmelding,Automatische meldingen van ontsnapping van een gevaarlijke stof via direct op de meldkamer aangesloten OMS en door PAC aan de meldkamer doorgegeven.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Autom. Gev stof,Gev. stof OMS": {
    description_value: "OMS gevaarlijke stof,Melding via OMS van detectie van een gevaarlijke stof.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Autom. Gev stof,Gev. stof PAC": {
    description_value: "PAC gevaarlijke stof,Binnenkomende meldingen via PAC van op PAC aangesloten automatische Gevaarlijke Stof detectiesystemen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Autom. systeemmelding,": {
    description_value: "Autom. systeemmelding,Alle binnenkomende meldingen via de OMS waarvoor, op basis van de aard van de melding, geen repressieve brandweer inzet nodig is. Het betreft in hoofdzaak storings-, onderhouds-, test en buiten werking stelling meldingen van OMS systemen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Hoog water alarm,": {
    description_value: "Hoogwateralarm,Alarmen/waarschuwingen afgegeven door Rijkswaterstaat/waterschappen i.v.m. dreigend bijzonder hoogwater.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Luid/optisch alarm,": {
    description_value: "Luid/optisch alarm,Melding door een persoon aan de meldkamer dat ergens een luid/optisch (bijvoorbeeld inbraak-, brand-, (co)gas alarm) hoor- of zichtbaar is, en waarop door de beheerder /gebruiker van het betreffende object niet gereageerd lijkt te worden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Luid/optisch alarm,CO-melder": {
    description_value: "CO-melder,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Luid/optisch alarm,Gebouw": {
    description_value: "Luid/optisch gebouw,Melding door een persoon aan de meldkamer dat uit/ in of aan een gebouw een luid/optisch (bijvoorbeeld inbraak-, brand-, (co)gas) alarm hoor- of zichtbaar is waarop door de beheerder/gebruiker van het betreffende object niet gereageerd lijkt te worden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Luid/optisch alarm,Rookmelder": {
    description_value: "Luid/optisch rookmelder,Melding door een persoon aan de meldkamer zonder dat diegene toegang heeft tot het object, maar voldoende kennis heeft van het object, om te bepalen dat in het object een rookmelder hoorbaar is. Verder zijn er geen indicaties dat er brand is, maar waarop vanuit/door de beheerder/gebruiker van het betreffende object niet gereageerd lijkt te worden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Luid/optisch alarm,Voertuig/Vaartuig": {
    description_value: "Luid/opt. voer-/vaartuig,Melding van een persoon aan de meldkamer dat uit/in of aan een voer-/vaartuig een luid/optisch (b.v. inbraak-, brand-, (co)gas) alarm hoor-/zichtbaar is waarop vanuit/door de beheerder/gebruiker van het betreffende object niet gereageerd lijkt te worden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,PAC alarm,": {
    description_value: "PAC alarm,Alarmmeldingen die via de PAC op de meldkamer binnenkomen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,PAC alarm,Inbraakalarm": {
    description_value: "Inbraakalarm PAC,Inbraakmeldingen die via de PAC binnenkomen van de op PAC aangesloten inbraak detectiesystemen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,PAC alarm,Overvalalarm": {
    description_value: "Overvalalarm PAC,(Drukknop) overvalmeldingen via de PAC aan de meldkamer doorgegeven, van systemen voor het doorgeven van een overvalmelding.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,PAC alarm,Persoonsalarm": {
    description_value: "Persoonsalarm PAC,Melding via de PAC van een persoonsgebonden noodoproepsysteem met de indicatie dat hulp van de OOV dienst nodig is.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,RAC alarm,": {
    description_value: "RAC alarm,Inbraakmeldingen die via de RAC binnenkomen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,RAC alarm,Inbraakalarm": {
    description_value: "Inbraakalarm RAC,Inbraakmeldingen die via de RAC binnenkomen van de op RAC aangesloten inbraakdetectie systemen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,RAC alarm,Overvalalarm": {
    description_value: "Overvalalarm RAC,(Drukknop) overvalmeldingen aan de meldkamer doorgegeven via de RAC, van systemen voor het doorgeven van een overvalmelding.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,RAC alarm,Persoonsalarm": {
    description_value: "Persoonsalarm RAC,Melding die rechtstreeks op de meldkamer binnenkomt van een speciaal voor het doorgeven van noodoproepen bedoeld, op de persoon, draagbaar middel. Dit is geen C2000-verbindingsmiddel.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Sensing,": {
    description_value: "Sensing,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Sensing,Alert": {
    description_value: "Alert,Alert is een hit vanuit een van de bij de marechaussee gebruikte sensing systemen ten behoeve van de grensbewaking van de lucht, land of zeegrenzen. ,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Sensing,ANPR-hit": {
    description_value: "ANPR-hit,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Sensing,Opsporingsmiddel": {
    description_value: "Opsporingsmiddel,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Sensing,Toezichtsalarm": {
    description_value: "Toezichtsalarm,Een gedetineerde of TBS-er krijgt een GPS band waardoor hij voordurend onder toezicht is. Als de betrokkene de naleving van bijzondere voorwaarde niet opvolgt, volgt er een melding naar de MKP.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Tunnelalarm,": {
    description_value: "Tunnelalarm,Automatische alarmmelding via vanuit tunnel zonder indicatie dat het een brandmelding betreft.,Er zijn automatische tunnel alarmen die geen aanduiding geven dat er brand is maar slechts dat er een trein stil staat terwijl dat daar niet de bedoeling is.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Alarm,Weeralarm,": {
    description_value: "Weeralarm,Alarmen/waarschuwingen afgegeven door meteorologische diensten i.v.m. dreigend gevaarlijk/extreem weer.,Het KNMI geeft verschillende waarschuwingen uit: een waarschuwing voor gevaarlijk weer, een waarschuwing voor extreem weer en een Weeralarm. Een waarschuwing voor gevaarlijk weer wordt maximaal 48 uur tevoren uitgegeven, een waarschuwing voor extreem weer maximaal 24 uur tevoren. Een waarschuwing voor extreem weer wordt uitgegeven als de kans dat het extreme weer optreedt 60 procent is of meer. Het Weeralarm wordt uitgegeven vanaf 12 uur voor het verschijnsel met een zekerheid van minstens 90 procent kan optreden. De KNMI waarschuwingen worden minstens elke drie uur geactualiseerd en wanneer daar aanleiding toe is nog vaker.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,,": {
    description_value: "Bezitsaantasting,Aantasting van andermans bezit of een poging daartoe.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,": {
    description_value: "Diefstal,Het wegnemen of toe-eigenen van enig goed dat geheel of gedeeltelijk aan een ander toebehoort.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Afpersing": {
    description_value: "Afpersing,Bij een afpersing (in de volksmond: chantage) probeert iemand zich wederrechtelijk te bevoordelen door een ander, al dan niet met geweld/smaad/laster/openbaarmaking, te dwingen iets te geven/te doen/niet te doen/te dulden. Dit kan gepaard gaan met een cybercomponent of seksueel getint materiaal. De daders willen geen politie-inmenging.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Beroving": {
    description_value: "Beroving,Met geweld of dreiging daartoe een persoon of goederen beroven in de openbare ruimte, niet zijnde een waardetransport.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Dier": {
    description_value: "Diefstal dier,Diefstal van een dier.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Fraude": {
    description_value: "Fraude,Het misleiden, bedriegen of schenden van vertrouwen met als doel een oneerlijk of onrechtvaardig voordeel danwel winst te verkrijgen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Goederen": {
    description_value: "Diefstal goederen,Diefstal van goederen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Heling": {
    description_value: "Heling,Heling is het afnemen, verkopen of verhandelen van hetgeen iemand anders gestolen heeft.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Luchtvaartuig": {
    description_value: "Diefstal luchtvaartuig,Diefstal van een luchtvaartuig.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Oplichting": {
    description_value: "Oplichting,Iemand bewegen tot afgifte van enig goed door middel van het aanwenden van bedrieglijke middelen of door het toepassen van listige kunstgrepen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Vaartuig": {
    description_value: "Diefstal vaartuig,Zie diefstal.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Verduistering": {
    description_value: "Verduistering,Het opzettelijk en wederrechtelijk toe-eigenen van enig goed dat geheel, of ten dele, aan een ander toebehoort en dat men anders dan door een misdrijf in het bezit gekregen heeft.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Voertuig": {
    description_value: "Diefstal voertuig,Diefstal van een voertuig,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Winkeldiefstal": {
    description_value: "Winkeldiefstal,Diefstal uit een winkel,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Diefstal,Zakkenrollerij": {
    description_value: "Zakkenrollerij,Diefstal door een zakkenroller,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Inbraak,": {
    description_value: "Inbraak,Door middel van braak zich wederrechtelijk toegang verschaffen, met het oogmerk om diefstal te plegen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Inbraak,Bedrijf/Instelling": {
    description_value: "Inbraak bedrijf/Inst.,Door middel van braak zich wederrechtelijk toegang verschaffen tot een bedrijf of instelling, met het oogmerk om diefstal te plegen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Inbraak,Bijgebouw": {
    description_value: "Inbraak bijgebouw,Door middel van braak zich wederrechtelijk toegang verschaffen, met het oogmerk om diefstal te plegen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Inbraak,Luchtvaartuig": {
    description_value: "Inbraak luchtvaartuig,Door middel van braak zich wederrechtelijk toegang verschaffen tot een luchtvaartuig, met het oogmerk om diefstal te plegen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Inbraak,Spoorvervoer": {
    description_value: "Inbraak spoorvervoer,Door middel van braak zich wederrechtelijk toegang verschaffen tot een railvoertuig, met het oogmerk om diefstal te plegen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Inbraak,Vaartuig": {
    description_value: "Inbraak vaartuig,Door middel van braak zich wederrechtelijk toegang verschaffen tot een vaartuig, met het oogmerk om diefstal te plegen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Inbraak,Voertuig": {
    description_value: "Inbraak voertuig,Door middel van braak zich wederrechtelijk toegang verschaffen tot een voertuig, met het oogmerk om diefstal te plegen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Inbraak,Woning": {
    description_value: "Inbraak woning,Door middel van braak zich wederrechtelijk toegang verschaffen tot een woning, met het oogmerk om diefstal te plegen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Overval,": {
    description_value: "Overval,Het dwingen tot afgifte van enig goed door middel van geweld of het dreigen met geweld met voorbedachte rade.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Overval,Bedrijf/Instelling": {
    description_value: "Overval bedrijf/inst.,Een geplande overval op een bedrijf of instelling,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Overval,Luchtvaartuig": {
    description_value: "Overval luchtvaartuig,Een geplande overval op of in luchtvaartuig niet zijnde een kaping.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Overval,Voertuig/Vaartuig": {
    description_value: "Overval voertuig/vaartuig,Een geplande overval op een voer- of vaartuig.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Overval,Waardetransport": {
    description_value: "Overval waardetransport,Het met geweld of bedreiging met geweld wegnemen of afpersen van enig goed, gepleegd tegen personen in een afgeschermde ruimte of op een gepland dan wel georganiseerd waardetransport of poging daartoe.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Overval,Woning": {
    description_value: "Overval woning,Een geplande overval op een particulier persoon vaak binnenshuis,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Stroperij,": {
    description_value: "Stroperij,Zonder geweld of dreiging daartoe, het geheel of ten dele, aan een ander toebehorende klei, bagger, veldvruchten, dieren etc. wegnemen met het oogmerk van toe-eigening.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Stroperij,Dier": {
    description_value: "Stroperij dier,Zonder geweld of dreiging daartoe, het geheel of ten dele, aan een ander toebehorende dier(en) wegnemen met het oogmerk van toe-eigening.,Het wederrechtelijk, dus zonder jachtakte en of benodigde vergunningen of ontheffingen, doden, verwonden, vangen, bemachtigen of met het oog daarop opsporen van dieren wordt vaak in de volksmond als wildstroperij aangemerkt. Dergelijk handelen is sinds 1 april 2002 opgenomen in de Flora- en faunawet.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Stroperij,Goederen": {
    description_value: "Stroperij goederen,Zonder geweld of dreiging daartoe, het geheel of ten dele, aan een ander toebehorende klei, bagger, veldvruchten etc. wegnemen met het oogmerk van toe-eigening.,Het wederrechtelijk, dus zonder jachtakte en of benodigde vergunningen of ontheffingen, doden, verwonden, vangen, bemachtigen of met het oog daarop opsporen van dieren wordt vaak in de volksmond als wildstroperij aangemerkt. Dergelijk handelen is sinds 1 april 2002 opgenomen in de Flora- en faunawet.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Vernieling,": {
    description_value: "Vernieling,Het opzettelijk en wederrechtelijk vernielen, beschadigen, onbruikbaar of wegmaken van enig goed dat aan een ander toebehoort.,Hoewel het moedwillig in brand steken van zaken als bijvoorbeeld straatmeubilair zeker als een vorm van vernieling gezien kan worden, is als een inzet van de brandweer gewenst is, het wenselijk dit als brand te classificeren.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Vernieling,Gebouw": {
    description_value: "Vernieling gebouw,Zie vernieling.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Vernieling,Goederen": {
    description_value: "Vernieling goederen,Zie vernieling.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Vernieling,Graffiti": {
    description_value: "Graffiti,Zie vernieling. Immers, het herstellen van de schade brengt zodanige kosten met zich mee dat van beschadiging mag worden uitgegaan.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Vernieling,Luchtvaartuig": {
    description_value: "Vernieling luchtvaartuig,Zie vernieling.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Vernieling,Spoorvervoer": {
    description_value: "Vernieling spoorvervoer,Zie vernieling.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Vernieling,Vaartuig": {
    description_value: "Vernieling vaartuig,Zie vernieling.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Bezitsaantasting,Vernieling,Voertuig": {
    description_value: "Vernieling voertuig,Zie vernieling.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,,": {
    description_value: "Brand,Incident waarbij het primair om brand gaat/ging of waarbij een explosie heeft plaatsgevonden met brand als overheersend effect tot gevolg.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Bijgebouw,": {
    description_value: "Brand bijgebouw,De BAG definieert als een bijgebouw: Een bijgebouw is een al dan niet vrijstaand pand dat dienstbaar is aan een hoofdgebouw en bevat geen verblijfsobjecten. Een pand zonder verblijfsobjecten heeft geen adres.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Buiten,": {
    description_value: "Buitenbrand,Alle buiten brandmeldingen, maar geen industrie/natuur/vervoer/scenario of gebouwen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Buiten,Afval/Rommel": {
    description_value: "Afvalbrand,Brandmelding van afval/rommel. Geen grote als industrieel aangemerkte objecten met opslag van afval. Rommel betreft die goederen die geen of weinig waarde hebben, buiten staande/opgeslagen gebruiksgoederen. ,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Buiten,Berm/Ruigte/Bosschage": {
    description_value: "Berm-/bosschagebrand,Brandmelding van begroeiing op een terrein dat op gebruiks-/natuurkaart en of in GMS NIET als bos heide veen of riet gebied aan te merken is.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Buiten,Container": {
    description_value: "Containerbrand,Brandmelding van, in principe alleen voor opslag van afval of goederen bedoelde, containers/bakken. De containers zijn bedoeld om menselijke activiteiten daarin te laten plaatsvinden (toilet-, douche-, schaftcontainers en dergelijke), en vallen onder gebouwen of kleine opstal.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Buiten,Industrie": {
    description_value: "Buitenbrand industrie,Brandmelding van industrieel aangemerkt terrein.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,": {
    description_value: "Brand gebouw,Brandmeldingen van/in gebouwen die niet vallen onder industriegebouwen of speciale scenario's. Een gebouw is elk vast of verplaatsbare, maar niet mobiel overdekte constructie, waarbinnen zich bij normaal gebruik of onderhoud mensen kunnen bevinden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,01 Woning/Woongebouw": {
    description_value: "Brand woning,Gebruiksfunctie voor het wonen. Woongebouw: gebouw of gedeelte van gebouw waarin twee of meer woonfuncties zijn ondergebracht, die zijn aangewezen op een of meer gemeenschappelijke verkeersroutes.,Nummering gebaseerd op BAG/Bouwwerkbesluit nummering",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,02 Bijeenkomst": {
    description_value: "Brand bijeenkomst,Gebruiksfunctie voor het samenkomen van mensen voor kunst, cultuur, godsdienst, communicatie, kinderopvang, verstrekken van consumpties voor het gebruik ter plaatse en aanschouwen sport,Nummering gebaseerd op BAG/Bouwwerkbesluit nummering.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,03 Cel": {
    description_value: "Brand cel,Gebruiksfunctie voor dwangverblijf van mensen. Cellengebouw: gebouw of gedeelte van gebouw waarin twee of meer celfuncties liggen, die zijn aangewezen op een of meer gemeenschappelijke verkeersroutes,Nummering gebaseerd op BAG/Bouwwerkbesluit nummering.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,04 Gezondheidszorg": {
    description_value: "Brand gezondheidszorg,Gebruiksfunctie voor medisch onderzoek, verpleging, verzorging of behandeling,Nummering gebaseerd op BAG/Bouwwerkbesluit nummering.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,05 Agrarisch": {
    description_value: "Brand agrarisch,Gebruiksfunctie voor het bedrijfsmatig bewerken of opslaan van materialen en goeden, of voor agrarische doeleinden.,Conformiteit Wet BAG, soort industrie is in de karakteristiek met waarden toegevoegd.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,05 Industrie": {
    description_value: "Brand industrie,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,06 Kantoor": {
    description_value: "Brand kantoor,Gebruiksfunctie voor administratie,Nummering gebaseerd op BAG/Bouwwerkbesluit nummering.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,07 Logies": {
    description_value: "Brand logies,Gebruiksfunctie voor het bieden van recreatief verblijf of tijdelijk onderdak aan mensen Bij de voorbeelden staan ook: vakantiehuisje, een trekkershut en stacaravan! Deze voorbeelden hebben wel logiesfunctie maar zijn geen logiesgebouw. De WOZ vertaal tabel plaatst ze bij de woningen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,08 Onderwijs": {
    description_value: "Brand onderwijs,Gebruiksfunctie voor het geven van onderwijs,Nummering gebaseerd op BAG/Bouwwerkbesluit nummering.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,09 Sport": {
    description_value: "Brand sport,Gebruiksfunctie voor het beoefenen van sport (Dus niet die voor het aanschouwen van sport. Die vallen onder bijeenkomst gebouw),",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,10 Winkel": {
    description_value: "Brand winkel,Gebruiksfunctie voor het verhandelen van materialen, goederen of diensten. Bij de voorbeelden staan ook: benzinestation, (auto)showroom, kaartverkoopkantoor, praktijkruimte dierenarts, kapsalon/pedicure, zonnestudie en bordeel.,Nummering gebaseerd op BAG/Bouwwerkbesluit nummering.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Gebouw,11 Overige": {
    description_value: "Brand overige gebouwen,Gebruiksfunctie van een deel van een gebouw, voor activiteiten waarbij het verblijven van mensen een ondergeschikte rol speelt en die niet valt onder de eerste tien meer specifiek benoemde gebruiksfuncties Met de subgroepen: voor personenvervoer, stallen motorvoertuigen, opslaan afval. Bij de voorbeelden staan: Parkeergarage, bergruimte of garage bij woning, wachtlokaal passagiers op station, telefooncel, transformatorgebouw, sanitairgebouw op camping, observatiehut in bos.,Nummering gebaseerd op BAG/Bouwwerkbesluit nummering.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Luchtvaart,": {
    description_value: "Brand luchtvaart,Brand in een op de grond staand luchtvaartuig, waarbij geen passagiers zijn betrokken / aanwezig zijn. (Bijv. een op een platform staand vliegtuig dat in de brand vliegt tijdens beladen of tanken),",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Natuur,": {
    description_value: "Natuurbrand,Brandmelding van begroeiing in een gebied wat op gebruiksdoeleinden-/natuurkaart/in GMS als natuur/bos/duin/heide/veen of riet gebied wordt aangemerkt.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Natuur,Akker/Weide": {
    description_value: "Akkerbrand,Brand van op akker/weide perceel aanwezige landbouwgewassen ook gras. Al dan niet gemaaid of op wiers liggend maar geen hooi/stro bulten of ander landbouwgewas (tussen) opslag op het veld waar het geoogst is.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Natuur,Bos": {
    description_value: "Bosbrand,Brandmelding van begroeiing in een gebied wat op gebruiksdoeleinden-/natuurkaart/in GMS als bosgebied wordt aangemerkt.,Het is vaak lastig vast te stellen of het nu specifiek dennenbos betreft. In gebieden waar het risico op grote bosbranden bestaat wordt voor die betreffende gebieden vaak gewerkt met de droogte risicofactor voor de bepaling van de omvang basisinzet. Omdat deze factor ook bij andere branden in deze gebieden een rol kan spelen is deze aan brand gekoppeld en niet alleen aan een bosbrand.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Natuur,Duin": {
    description_value: "Duinbrand,Brandmelding van begroeiing in een gebied wat op gebruiksdoeleinden-/natuurkaart/in GMS als duingebied wordt aangemerkt.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Natuur,Heide": {
    description_value: "Heidebrand,Brandmelding van begroeiing in een gebied wat op gebruiksdoeleinden-/natuurkaart/in GMS als heidegebied wordt aangemerkt.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Natuur,Riet": {
    description_value: "Rietbrand,Brandmelding van begroeiing in een gebied wat op gebruiksdoeleinden-/natuurkaart/in GMS als rietvelden wordt aangemerkt. Het gaat hier om grotere oppervlaktes en dus niet om een strook riet langs een sloot of waterweg. In die laatste gevallen gaat het om een buitenbrand berm/ruigte of bosschage.,Het branden van een rietveld is opgenomen in verband met de vaak moeizame bereikbaarheid.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Natuur,Veen": {
    description_value: "Veenbrand,Brandmelding van begroeiing en of veenbodem in gebied dat op gebruiksdoeleinden-/ natuur kaart/ in GMS als veengebied wordt aangemerkt.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Scheepvaart,": {
    description_value: "Brand scheepvaart,Brandmelding van/in vaartuig met uitzondering van drijvende objecten die in verband met de primaire functie zelden verplaatst worden zoals een woonboot, gevangenisboot, hotelschip en dergelijke.,Ook al ligt een (plezier) jacht aan de wal, dan is het nog niet overal altijd via de weg bereikbaar en moet er dus makkelijk voor de inzet boot te kiezen zijn.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Specifiek,": {
    description_value: "Brand specifiek,Classificatie voor brandmeldingen waarbij naar verwachting geen, of geen omvangrijke, brandweerinzet (meer) nodig is. En het type object, in principe, niet bepalend is voor de inzet.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Specifiek,Brandgerucht": {
    description_value: "Brandgerucht,Meldingen waarbij het zeer twijfelachtig is of er een te blussen brand is. Dit omdat de melder alleen een brandlucht waarneemt of alleen rook of vuurverschijnselen op afstand meldt, waarbij de melder niet kan aangeven wat er dan mogelijk in brand staat.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Specifiek,Nablussen": {
    description_value: "Nablussen,Meldingen dat er op locatie waar, niet al te lang daarvoor een brand is geblust, het opnieuw begint te branden. Dit is echter niet zodanig dat een inzet met spoed nodig geacht wordt.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Specifiek,Nacontrole": {
    description_value: "Nacontrole brand,Melding van mensen die zelf een brandje geblust hebben maar er niet 100 procent zeker van zijn dat het uit is, of die na blikseminslag zonder direct waarneembare brandverschijnselen aangeven er niet zeker van te zijn of die echt geen brand veroorzaakt heeft en de brandweer verzoeken een nacontrole te doen, of er echt geen brand meer is.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Spoorvervoer,": {
    description_value: "Brand spoorvervoer,Brandmelding van/in spoorvervoermiddel maar niet in een tunnel of in een station. Indien vervoermiddel in tunnel en/of onderstations overkapping dan wel direct tegen stationsgebouw, dan gebouwbrand betreffende tunnel en/of stationsobject.,Indien het een TIS 24 stationbrand of TIS 24 tunnel betreft dan IB betreffend object.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Brand,Wegvervoer,": {
    description_value: "Brand wegvervoer,Brandmelding van/in wegvervoermiddel en (land/wegen)bouwmachine op de weg of in het vrije veld. Indien de brand in de tunnel/onder viaduct of in/direct tegen gebouw is, dan voor gebouwbrand, en zo mogelijk betreffend object(type) kiezen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,,": {
    description_value: "Dienstverlening,Het verlenen van hulp en diensten aan derden en aan de eigen dienst. Niet betreffende de directe inzet voor een incident of besteld vervoer tenzij het grootschalige bijstand buiten de regio/ werkingsgebied meldkamer betreft.,Bij de brandweer valt inzet buiten het werkingsgebied van de meldkamer volgens KVT hier niet onder maar wel de inzet van voorbereide pelotons/compagnie.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Ambulancezorg,": {
    description_value: "Dienstverlening ambuzorg,Het verlenen van hulp en leveren van diensten door de ambulancedienst aan derden en de eigen dienst. Niet zijnde directe inzet tenzij het grootschalige bijstand buiten de regio/werkingsgebied betreft.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Ambulancezorg,Afgebroken inzet": {
    description_value: "Afgebroken inzet,Een gestartte versnelde inzet waarbij na triage duidelijk is dat er geen inzet benodigd is.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Ambulancezorg,Afstemverzoek": {
    description_value: "Ambulancezorg afstemverz,Verzoek van de alarmcentrale aan contactpersoon van de ambulancedienst in een bepaald gebied, om contact op te nemen met de meldkamer voor overleg hoe om te gaan met een niet spoedeisende, mogelijk nog nader te classificeren zaak.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Ambulancezorg,Bijstand": {
    description_value: "Ambulancezorg bijstand,Bijstand aanvraag/-inzet van de ambulancedienst voor (grootschalige) inzet buiten het werkgebied van de meldkamer,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Ambulancezorg,Dienst aan derden": {
    description_value: "Ambuzorg dienst aan derd,Het verlenen van diensten aan derden door de ambulancedienst,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Ambulancezorg,Geplande actie": {
    description_value: "Ambuzorg geplande actie,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Ambulancezorg,Oefening": {
    description_value: "Ambulancezorg oefening,Het verwerken van een fictief incident, voor trainingsdoeleinden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Ambulancezorg,Opnamestop": {
    description_value: "Ambulancezorg opnamestop,Indien een ziekenhuis een opnamestop afkondigt.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Ambulancezorg,Testmelding": {
    description_value: "Ambulancezorg testmelding,Het verwerken van een testmelding, voor doeleinden om berichtaflevering/aansturing te testen,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Ambulancezorg,VWS": {
    description_value: "VWS,Voorwaardescheppend,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Brandweer,": {
    description_value: "Dienstverlening brandweer,Het verlenen van hulp en leveren van diensten door de brandweer aan derden en de eigen dienst. Niet zijnde directe inzet voor een incident tenzij het grootschalige bijstand buiten de regio/werkingsgebied betreft.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Brandweer,Afstemverzoek": {
    description_value: "Brandweer afstemverzoek,Verzoek van de alarmcentrale aan contactpersoon van de brandweer in een bepaald gebied, om contact op te nemen met de meldkamer voor overleg hoe om te gaan met een niet spoedeisende, mogelijk nog nader te classificeren zaak.,De meldingclassificatie is afstem verzoek want daar gaat het feitelijk om. In de apart in te stellen alarmeringstekst kan dit desgewenst vertaald worden naar Direct contact meldkamer of iets dergelijks.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Brandweer,Bijstand": {
    description_value: "Brandweer bijstand,Bijstand aanvraag/-inzet van de brandweer voor (grootschalige) inzet buiten het werkgebied van de alarmcentrale.,Voor bijstand Brw. naar gebied buiten werkgebied AC.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Brandweer,Dienst aan derden": {
    description_value: "Brandweer dienst aan derd,Het verlenen van diensten aan derden door de Brandweer,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Brandweer,Geplande actie": {
    description_value: "Brandweer geplande actie,Acties van de brandweer die, op zich, niet op onverwacht voordoende incidenten gebaseerd zijn maar van te voren gepland zijn. Onder andere bij oefeningen en stand-by staan bij evenementen.,Bijvoorbeeld stand- by bij activiteiten.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Brandweer,Herbez./Kazern.": {
    description_value: "Brandweer Herbez./Kazern.,Acties van de brandweer om een kazerne die zelf geen eenheden meer kan leveren, in verband met de inzet, bij een incident of anderszins bezet te krijgen voor de noodzaakelijk geachte dekking in een bepaald gebied.,Hier gaat het om herbezetting die niet altijd koppelbaar is aan een specifiek bestaand incident.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Brandweer,Liftopsluiting": {
    description_value: "Liftopsluiting,Melding van/inzet voor mensen die vast in een lift zitten waarbij inzet van de brandweer wenselijk geacht wordt in verband met lange wachttijd op de liftmonteur.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Brandweer,Oefening": {
    description_value: "Brandweeroefening,Het verwerken van een fictief incident, voor trainingsdoeleinden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Brandweer,Testmelding": {
    description_value: "Brandweer testmelding,Het verwerken van een testmelding, voor doeleinden om berichtaflevering/aansturing te testen,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Dienst door derden,": {
    description_value: "Dienst door derden,Het gaat hier om een bij de MK binnen gekomen hulpvraag waarvan geconcludeerd wordt dat het niet nodig is 1 van de disciplines te betrekken (anders dan de centralist waarbij die binnen gekomen is) en die niet onder 1 van de andere MC’s te plaatsen is en die beter door een andere niet direct aan de OOV diensten gelieerde partij af te handelen is.,Dit is een uitkomst van ProQA Fire die wij op dit moment nergens anders in de LMC set aan weten te koppelen. Hoe vaak mensen in NL voor dit soort zaken 112 bellen is niet bekend maar je zou je voor kunnen stellen dat, dat ook in NL wel eens gebeurd dat mensen 112 bellen voor hulp waarbij de centralist al heel snel tot de conclusie komt hiervoor moet je niet bij de OOV diensten zijn.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Dieren,": {
    description_value: "Dienstverlening dieren,Hulpverlening in verband met dieren.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Dieren,Dier in problemen": {
    description_value: "Dier in problemen,Hulpverlening aan een dier in problemen, niet specifiek benoemd.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Dieren,In of op ijs": {
    description_value: "Dier in of op ijs,Hulpverlening aan een dier dat door het ijs is gezakt of dreigt te zakken of is vastgevroren en waarvan naar redelijkheid niet verwacht kan worden dat het zelfstandig uit het water/van het ijs kan komen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Dieren,In put/bassin/kelder": {
    description_value: "Dier in put/bassin/kelder,Hulpverlening aan een dier dat zich bevindt in een opslagruimte voor vloeistof/mest of andere stof waarin het kan zinken.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Dieren,Op hoogte": {
    description_value: "Dier op hoogte,Hulpverlening aan een dier dat zich op een plek hoog boven de grond bevindt waarvan redelijkerwijs niet verwacht mag worden dat het dier zelf weer de normale leefomgeving kan bereiken.,De diersoort bepaald op diverse plaatsen in het land wel/niet/soort inzet van de brandweer.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Dieren,Te water": {
    description_value: "Dier te water,Hulpverlening aan een dier dat te water is geraakt en waarvan naar alle redelijkheid niet verwacht kan worden dat het zelfstandig weer uit het water kan komen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,KMAR,": {
    description_value: "Dienstverlening KMAR,Inzet van de KMAR.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,KMAR,Afstemverzoek": {
    description_value: "KMAR afstemverzoek,Verzoek van de alarmcentrale aan contactpersoon van de KMAR in een bepaald gebied, om contact op te nemen met de meldkamer voor overleg hoe om te gaan met een niet spoedeisende, mogelijk nog nader te classificeren zaak.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,KMAR,Begeleiden": {
    description_value: "KMAR begeleiden,Inzet van de KMAR bij de begeleiding van personen  en goederen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,KMAR,Beveil. waardetransport": {
    description_value: "KMAR bev. waardetransp.,Inzet van de KMAR bij het beveiligen van een waardetransport.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,KMAR,Bijstand": {
    description_value: "KMAR bijstand,Bijstand aanvraag/-inzet van de KMAR.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,KMAR,Dienst aan derden": {
    description_value: "KMAR dienst aan derden,Het verlenen van diensten aan derden door de KMAR,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,KMAR,Geplande actie": {
    description_value: "KMAR geplande actie,Acties van de KMAR die, op zich, niet op onverwacht voordoende incidenten gebaseerd zijn maar van te voren gepland zijn. Onder andere bij oefeningen en stand-by staan bij evenementen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,KMAR,Signalering": {
    description_value: "KMAR signalering,Signalering uit een opsporingssysteem, niet zijnde via sensing.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,KMAR,Testmelding": {
    description_value: "KMAR testmelding,Het verwerken van een testmelding, voor doeleinden om berichtaflevering/aansturing te testen,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Multi,": {
    description_value: "Dienstverlening multi,Het verlenen van hulp en leveren van diensten door meerdere disciplines aan derden en de eigen dienst.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Multi,Afstemverzoek": {
    description_value: "Multi afstemverzoek,Verzoek van de alarmcentrale aan contactpersoon van de politie in een bepaald gebied, om contact op te nemen met de meldkamer voor overleg hoe om te gaan met een niet spoedeisende, mogelijk nog nader te classificeren zaak.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Multi,Buitensluiting": {
    description_value: "Buitensluiting,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Multi,Geplande actie": {
    description_value: "Multi geplande actie,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Multi,Oefening": {
    description_value: "Multi oefening,Het verwerken van een fictief incident, voor trainingsdoeleinden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Multi,Overname meldkamer": {
    description_value: "Overname meldkamer,Het overnemen van een meldkamer door een andere meldkamer.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Multi,Testmelding": {
    description_value: "Multi testmelding,Het verwerken van een testmelding, voor doeleinden om berichtaflevering/aansturing te testen,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Multi,Uitval meldkamer": {
    description_value: "Uitval meldkamer,De melding aan de disciplines dat de meldkamer beperkt of niet functioneert.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Multi,Uitval systeem": {
    description_value: "Uitval systeem,De melding aan de disciplines dat C2000 is uitgevallen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,": {
    description_value: "Dienstverlening politie,Het verlenen van hulp en leveren van diensten door de politie aan derden en de eigen dienst. Niet zijnde directe inzet voor een incident tenzij het grootschalige bijstand buiten de regio/werkingsgebied betreft.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Aan instanties": {
    description_value: "Politie dienst aan inst.,Het verlenen van hulp en leveren van diensten door de politie aan instanties.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Aantreffen van": {
    description_value: "Aantreffen van,De inzet van de politie in het kader van het aantreffen van personen of goederen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Afstemverzoek": {
    description_value: "Politie afstemverzoek,Verzoek van de alarmcentrale aan contactpersoon van de politie in een bepaald gebied, om contact op te nemen met de meldkamer voor overleg hoe om te gaan met een niet spoedeisende, mogelijk nog nader te classificeren zaak.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Begeleiden": {
    description_value: "Politie begeleiden,Inzet van de politie bij de begeleiding van personen  en goederen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Bijstand": {
    description_value: "Politie bijstand,Bijstand aanvraag/-inzet van de politie voor (grootschalige) inzet buiten het werkgebied van de alarmcentrale.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Controle Wet ID": {
    description_value: "Controle wet ID,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Dienst aan derden": {
    description_value: "Politie dienst aan derden,Het verlenen van diensten aan derden door de politie.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Eigen initiatief": {
    description_value: "Politie eigen initiatief,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Geplande actie": {
    description_value: "Politie geplande actie,Acties van de politie die, op zich, niet op onverwacht voordoende incidenten gebaseerd zijn maar van te voren gepland zijn. Onder andere bij oefeningen en stand-by staan bij evenementen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Oefening": {
    description_value: "Politie oefening,Het verwerken van een fictief incident, voor trainingsdoeleinden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Overbrengen": {
    description_value: "Politie overbrengen,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Testmelding": {
    description_value: "Politie testmelding,Het verwerken van een testmelding, voor doeleinden om berichtaflevering/aansturing te testen,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Dienstverlening,Politie,Vermissing": {
    description_value: "Vermissing,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Gezondheid,,": {
    description_value: "Gezondheid,Gezondheidsproblemen die niet gerelateerd zijn aan brand of een ongeval (of andere MC).,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Gezondheid,Onwel/Ziekte,": {
    description_value: "Onwel/ziekte,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Gezondheid,Poging zelfdoding,": {
    description_value: "Poging zelfdoding,Er is een melding voor een van de disciplines van poging tot zelfdoding.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Gezondheid,Reanimatie,": {
    description_value: "Reanimatie,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Gezondheid,Suicidaal persoon,": {
    description_value: "Suicidaal persoon,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Hulpvraag,,": {
    description_value: "Hulpvraag,Hulpaanvragen die bij de meldkamer binnenkomen,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Hulpvraag,Ambulancezorg,": {
    description_value: "Hulpvraag ambuzorg,Hulpaanvragen die bij de ambulanzezorg binnenkomen,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Hulpvraag,Ambulancezorg,Directe inzet": {
    description_value: "Directe inzet,De centralist van de meldkamer ambulancezorg stuurt op basis van een 112-melding zo snel als mogelijk en voor afronding van de triage een ambulance-eenheid in de richting van het incident. Het uitsturen van de ambulance gebeurt met een A2-urgentie. Triage, terwijl de ambulance al onderweg is, kan aanleiding geven de inzetopdracht en/of de urgentie bij te stellen of eventueel zelfs de inzetopdracht af te breken.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Hulpvraag,Ambulancezorg,Versnelde inzet": {
    description_value: "Versnelde inzet,De centralist van de meldkamer ambulancezorg stuurt op basis van een 112-melding of melding van een zorg professional vanuit NTS zo snel als mogelijk en voor afronding van de triage een ambulance-eenheid in de richting van het incident. Het uitsturen van de ambulance gebeurt met een A1- of A2-urgentie (keuze vanuit NTS). Triage, terwijl de ambulance al onderweg is, kan aanleiding geven de urgentie bij te stellen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,,": {
    description_value: "Leefmilieu,Aantasting van de leefomgeving (hinder) of dreiging daartoe, zonder directe of indirecte invloed op de gezondheid van mensen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Aardschok,": {
    description_value: "Aardschok,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Conflict,": {
    description_value: "Conflict,Een situatie waarin twee of meer mensen tegengestelde opvattingen hebben.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Conflict,Burenruzie": {
    description_value: "Burenruzie,Een conflict tussen buren.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Conflict,Conflictbemiddeling": {
    description_value: "Conflictbemiddeling,Een conflict tussen twee (samenwonende) personen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Conflict,Hulpverlener": {
    description_value: "Conflict hulpverlener,Een conflict tussen een burger en een hulpverlener van een particuliere- of overheidsinstelling.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Dieren,": {
    description_value: "Leefmilieu dieren,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Dieren,Agressieve dieren": {
    description_value: "Agressieve dieren,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Dieren,Dierenkwelling": {
    description_value: "Dierenkwelling,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Dieren,Zieke/Dode dieren": {
    description_value: "Zieke/dode dieren,Aantreffen van zieke en/of dode dieren.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Overlast van/door,": {
    description_value: "Overlast,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Overlast van/door,Dieren": {
    description_value: "Overlast dier,Overlast veroorzaakt door dieren, waaronder blaffende honden en bijenzwermen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Overlast van/door,Geluid": {
    description_value: "Overlast geluid,Overlast veroorzaakt door geluid in de woonomgeving.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Overlast van/door,Jeugd": {
    description_value: "Overlast jeugd,Het veroorzaken van overlast door jeugdige personen, waaronder zogenaamde hangjongeren.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Overlast van/door,Persoon": {
    description_value: "Overlast persoon,Het veroorzaken van overlast door een individueel persoon.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Overlast van/door,Verkeer": {
    description_value: "Overlast verkeer,Overlast veroorzaakt door weg-, water-, spoor- en luchtverkeer.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Overlast van/door,Vuurwerk": {
    description_value: "Overlast vuurwerk,Overlast ten gevolge van het afsteken van vuurwerk.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Stank/Hinder. Lucht,": {
    description_value: "Stank/hinderlijke lucht,Overlast van stinkende stoffen, bijvoorbeeld door chemisch stoffen of het uitrijden van mest.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Uitval nutsvoorziening,": {
    description_value: "Uitval nutsvoorziening,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Verontreiniging,": {
    description_value: "Verontreiniging,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Verontreiniging,Bodem": {
    description_value: "Bodemverontreiniging,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Verontreiniging,Lucht": {
    description_value: "Luchtverontreiniging,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Verontreiniging,Object": {
    description_value: "Verontreiniging object,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Verontreiniging,Oppervlaktewater": {
    description_value: "Verontreiniging opp.water,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Water/weer problemen,": {
    description_value: "Water/weer probleem,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Water/weer problemen,Gladheid/Sneeuw": {
    description_value: "Gladheid/sneeuw problemen,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Water/weer problemen,Hoogwater": {
    description_value: "Hoogwater,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Water/weer problemen,Overstroming/Dijkdoorbraak": {
    description_value: "Overstroming/dijkdoorbr.,,Dam-/kade-/dijk-/duin-doorbraak/overstroming.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Water/weer problemen,Stormschade": {
    description_value: "Stormschade,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Water/weer problemen,Warmte/Droogte": {
    description_value: "Warmte/droogte problemen,,Denk aan koelen bruggen, veestallen en dergelijke.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Leefmilieu,Water/weer problemen,Wateroverlast": {
    description_value: "Wateroverlast,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,,": {
    description_value: "Ongeval,Een onvoorziene gebeurtenis met urgentie waarbij op enige wijze schade is veroorzaakt (ontstaan) aan mensen of goederen waarbij het niet primair om brand of een explosie gaat. Alleen onder luchtvaartongevallen worden ook alle branden van luchtvaartuigen gerekend.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Luchtvaart,": {
    description_value: "Luchtvaartongeval,Een onvoorziene gebeurtenis waarbij een vliegtuig is betrokken.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Luchtvaart,Crash": {
    description_value: "Crash luchtvaart,Een onvoorziene landing of neerstorting of aanrijding met ernstige gevolgen. (Bijv. vliegtuig stort neer tijdens landing, twee vliegtuigen komen op de start-/landingsbaan met elkaar in botsing, een helikopter raakt hoogspanningskabel en stort neer),De lokale incident aanduidingen zoals VOS, VOR e.d. kunnen hieraan en aan de bij behorende POB categorie gekoppeld worden via parsertermen en indien gewenst ook nog een specifieke karakteristiek met de lokale benamingen.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Luchtvaart,Gevaarlijke stof": {
    description_value: "Luchtvaart gev. stof,Een ongeval (incident) met gevaarlijke stoffen (niet zijnde een crash, noodsituatie of voorzorgslanding), vanuit een luchtvaartuig.,Het gaat dan om ongevallen, waarbij de gevaarlijke stof de hoofdrol heeft en dus het grootste gevaar is. Bij brand is altijd de brand het grootste gevaar en bepalend voor het incidenttype. Het vrijkomen van GS (wat altijd is bij brand) is dan het effect. Voor deze gevallen kan men de KAR ‘met GS’ altijd gebruiken.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Luchtvaart,Noodsituatie": {
    description_value: "Noodsituatie luchtvaart,Piloot doet May Day Call. Hierbij is sprake van een ernstige situatie waarbij direct levensgevaar voor de aanwezigen is of kan ontstaan en waarbij direct assistentie is vereist. Het luchtvaartuig wil voorrang op alle luchtvaartbewegingen om te landen.,De lokale incident aanduidingen zoals VOS, VOR e.d. kunnen hieraan en aan de bij behorende POB categorie gekoppeld worden via parsertermen en indien gewenst ook nog een specifieke karakteristiek met de lokale benamingen.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Luchtvaart,Overig LVO": {
    description_value: "Luchtvaart ongeval overig,Onder de luchtvaart ongevallen vallende overige incidenten met luchtvaartuig, wat de luchthaven in eerste instantie zelf af kan met de luchthavenbrandweer. (Dit zijn geen crashes, runway incursion, voorzorgslandingen, etc.),De lokale incident aanduidingen zoals VOS, VOR e.d. kunnen hieraan en aan de bij behorende POB categorie gekoppeld worden via parsertermen en indien gewenst ook nog een specifieke karakteristiek met de lokale benamingen. Op kleinere vliegvelden kan het zijn dat men er toch voor kiest om bij de grote POB klassen vast overheidshulpdiensten op te roepen i.v.m. langere aanrijdtijden.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Luchtvaart,Voorzorg": {
    description_value: "Luchtvaart voorzorg,Een melding uit voorzorg (pan pan call) met als doel vroegtijdig maatregelen te kunnen treffen of hulpverlening op te starten. Er wordt nog geen ernstig incident verwacht en de luchthaven moet het incident in principe met eigen potentieel af kunnen handelen.,De lokale incident aanduidingen zoals VOS, VOR e.d. kunnen hieraan en aan de bij behorende POB categorie gekoppeld worden via parsertermen en indien gewenst ook nog een specifieke karakteristiek met de lokale benamingen. Op kleinere vliegvelden kan het zijn dat men er toch voor kiest om bij de grote POB klassen vast overheidshulpdiensten op te roepen i.v.m. langere aanrijdtijden.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Overig,": {
    description_value: "Ongeval overig,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Overig,Gevaarlijke stof": {
    description_value: "Ongeval gev. stof,Een ongeval (incident) (niet zijnde luchtvaart, spoorvervoer, water of wegvervoer), waarbij gevaarlijke stoffen betrokken zijn en deze stof(fen) het grootste gevaar van het incident zijn voor de hulpverleners en de omgeving.(bijvoorbeeld het vrijkomen van een gevaarlijke stof uit een installatie bij een bedrijf),Het gaat dan om ongevallen, waarbij de gevaarlijke stof de hoofdrol heeft en dus het grootste gevaar is. Bij brand is altijd de brand het grootste gevaar en bepalend voor het incidenttype. Het vrijkomen van GS (wat altijd is bij brand) is dan het effect. Voor deze gevallen kan men de KAR ‘met GS’ altijd gebruiken.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Overig,Letsel": {
    description_value: "Ongeval overig letsel,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Overig,Materieel": {
    description_value: "Ongeval overig materieel,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Spoorvervoer,": {
    description_value: "Ongeval spoorvervoer,Een ongeval op het spoor.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Spoorvervoer,Gevaarlijke stof": {
    description_value: "Ongeval spoor gev. stof,Een ongeval (incident) met gevaarlijke stoffen op het spoor ( bijvoorbeeld een lekkende ketelwagon),Het gaat dan om ongevallen, waarbij de gevaarlijke stof de hoofdrol heeft en dus het grootste gevaar is. Bij brand is altijd de brand het grootste gevaar en bepalend voor het incidenttype. Het vrijkomen van GS (wat altijd is bij brand) is dan het effect. Voor deze gevallen kan men de KAR ‘met GS’ altijd gebruiken.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Spoorvervoer,Letsel": {
    description_value: "Ongeval spoor letsel,Een ongeval op het spoor met (ander) voertuig of voorwerp waarbij enig menselijk letsel is ontstaan.,Belangrijk om zo snel mogelijk te achterhalen of er alleen dodelijke slachtoffers zijn of ook gewonden/beknelden. Bij een goederentrein moet nagegaan worden of er ook een brand of lekkage van gevaarlijke stoffen optreedt.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Spoorvervoer,Materieel": {
    description_value: "Ongeval spoor materieel,Een ongeval op het spoor met (ander) voertuig of voorwerp waarbij slechts sprake is van materiele schade.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Water,": {
    description_value: "Ongeval water,Een ongeval te water.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Water,Gevaarlijke stof": {
    description_value: "Ongeval water gev. stof,Een ongeval (incident) met gevaarlijke stoffen op het water ( bijvoorbeeld een lekkende tank/compartiment van een binnenvaartschip),Het gaat dan om ongevallen, waarbij de gevaarlijke stof de hoofdrol heeft en dus het grootste gevaar is. Bij brand is altijd de brand het grootste gevaar en bepalend voor het incidenttype. Het vrijkomen van GS (wat altijd is bij brand) is dan het effect. Voor deze gevallen kan men de KAR ‘met GS’ altijd gebruiken.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Water,Lek/zinken woonboot": {
    description_value: "Lek/zinken woonboot,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Water,Letsel": {
    description_value: "Ongeval water letsel,Een ongeval te water waarbij enig menselijk letsel is ontstaan.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Water,Materieel": {
    description_value: "Ongeval water materieel,Een ongeval te water waarbij slechts van materiele schade sprake is.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Water,Noodsignaal": {
    description_value: "Water noodsignaal,Een (melding) waarneming signaal dat wordt uitgezonden/gegeven om aan te geven dat een vaartuig in nood verkeert en waarbij geen direct mondeling contact is met de opvarende op het vaartuig, en door de waarnemer ook niet vast te stellen is dat er zich daadwerkelijk een vaartuig in nood verkeert.,Denk hierbij aan een (vage) vuurpijl melding zonder ander noodsignaal.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Water,Persoon in drijfzand": {
    description_value: "Persoon in drijfzand,Een persoon in nood die zich in drijfzand begeeft.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Water,Persoon te water": {
    description_value: "Persoon te water,Een persoon in nood die te water is geraakt en niet in het bezit is van een drijfmiddel (drenkeling).,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Water,Schip/watersp. in problemen": {
    description_value: "Schip/watersp. in probl.,Een vaartuig waarover de bemanning de controle heeft verloren of welke in gevaar verkeert. Dit wordt bepaald op basis van direct contact met opvarenden, of door waarneming van de toestand van het vaartuig door derden.,Volgens de wet en Waterrand omvat de term schip ook kleine bootjes zoals kano?s, surfers en boarders . Op nadrukkelijk verzoek van Waterrand vertegenwoordigers wordt ter in de MC naast Schip Watersp. Toegevoegd in de MC ter verduidelijking dat kano?s, surfers e.d. hier ook onder vallen.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Wegvervoer,": {
    description_value: "Ongeval wegvervoer,Een ongeval op de weg.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Wegvervoer,Gevaarlijke stof": {
    description_value: "Ongeval weg gev. stof,Een ongeval (incident) met gevaarlijke stoffen op de weg / vanuit een voertuig ( bijvoorbeeld een lekkende tankwagen),Het gaat dan om ongevallen, waarbij de gevaarlijke stof de hoofdrol heeft en dus het grootste gevaar is. Bij brand is altijd de brand het grootste gevaar en bepalend voor het incidenttype. Het vrijkomen van GS (wat altijd is bij brand) is dan het effect. Voor deze gevallen kan men de KAR ‘met GS’ altijd gebruiken.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Wegvervoer,Letsel": {
    description_value: "Ongeval weg letsel,Een ongeval waarbij een voertuig (wegvervoer) is betrokken waarbij enig lichamelijk letsel is ontstaan.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Wegvervoer,Materieel": {
    description_value: "Ongeval weg materieel,Een ongeval waarbij een voertuig (wegvervoer) is betrokken en waarbij slechts sprake is van materiele schade.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Ongeval,Wegvervoer,Voertuig te water": {
    description_value: "Voertuig te water,Een ongeval waarbij een voertuig (wegvervoer) te water is geraakt.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,,": {
    description_value: "Veiligheid en openb. orde,Aantasting van de lichamelijke integriteit van persoon of dreiging met maatschappelijke gevolgen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Aantast. Openb orde,": {
    description_value: "Aantasting openbare orde,Verstoring van de openbare orde,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Aantast. Openb orde,Demonstratie": {
    description_value: "Demonstratie,Een spontane of aangekondigde betoging op de openbare weg door een of meerdere personen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Aantast. Openb orde,Evenementen": {
    description_value: "Evenementen,Een spontane of aangekondigde gebeurtenis op de openbare weg door eenn of meerdere personen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Aantast. Openb orde,Huis/lok. vredebreuk": {
    description_value: "Huis-/lokaalvredebreuk,Het wederrechtelijk binnendringen van een woning of lokaliteit.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Aantast. Openb orde,Onbevoegd betreden": {
    description_value: "Onbevoegd betreden,Zonder toestemming van de eigenaar betreden van een terrein of gebouw.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Aantast. Openb orde,Overtreding avondklok": {
    description_value: "Overtreding avondklok,Zonder toestemming zich in de openbaarheid begeven gedurende de periode dat een avondklok van toepassing is,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Aantast. Openb orde,Samenscholing": {
    description_value: "Samenscholing,Samen zijn van een groep personen dat als hinderlijk wordt ervaren.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Aantast. Openb orde,Stalking": {
    description_value: "Stalking,Iemand opzettelijk en structureel lastigvallen, waardoor die persoon zich in zijn of haar vrijheid en veiligheid voelt aangetast.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Beveiliging,": {
    description_value: "Beveiliging,Beveiligingswerkzaamheden uitgevoerd door 1 of meerdere eenheden van de politie en/of KMAR.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Beveiliging luchtvaart,": {
    description_value: "Beveiliging luchtvaart,Incidenten met betrekking tot vliegvelden en vliegtuigen van de burgerluchtvaart.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Beveiliging luchtvaart,Onbeheerde bagage": {
    description_value: "Onbeheerde bagage,Aantreffen van bagage zonder dat een eigenaar waarneembaar is.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Beveiliging luchtvaart,Security incident": {
    description_value: "Security incident,Incident waarvoor 'security' protocollen gelden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Beveiliging luchtvaart,Startverbod vliegtuig": {
    description_value: "Startverbod vliegtuig,Een of meerdere vliegtuigen is verboden op te starten.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Beveiliging luchtvaart,Steekproef security": {
    description_value: "Steekproef security,Vanuit beveiligingsoverweging steekproefsgewijs extra controle uitvoeren.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Beveiliging luchtvaart,Vluchtafhandeling": {
    description_value: "Vluchtafhandeling,Beveiliging incheck, bagage, passagiers, platform etcetera.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Bijzondere Wetten,": {
    description_value: "Bijzondere Wetten,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Bijzondere Wetten,GB Controle": {
    description_value: "GB Controle,Controle aan de Nederlandse grens,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Bijzondere Wetten,Militaire Zaken": {
    description_value: "Militaire Zaken,Meldingen met betrekking tot het militair tucht of strafrecht, welke niet onder een andere MC’s kunnen vallen, of andere zaken met betrekking tot de Nederlandse Krijgsmacht. ,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Bijzondere Wetten,MTV Controle": {
    description_value: "MTV Controle,Controle aan de Schengen binnengrens van het Koninkrijk. (NL-DU en NL-BE) ,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Bijzondere Wetten,Veiligheidscontrole WWM": {
    description_value: "Veiligheidscontrole WWM,Veiligheidscontrole Wet Wapens en Munitie,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Bijzondere Wetten,Vreemdelingenzaak": {
    description_value: "Vreemdelingenzaak,Overige vreemdelingenzaken, niet zijnde GB of MTV,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Digitaal,": {
    description_value: "Digitaal,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Digitaal,Cybercrime": {
    description_value: "Cybercrime,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Digitaal,Digitale criminaliteit": {
    description_value: "Digitale criminaliteit,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Drugszaak,": {
    description_value: "Drugszaak,Alle meldingen met betrekking tot het bezit en gebruik van drugs.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Drugszaak,Dealen": {
    description_value: "Dealen,Het (illegaal) handelen in drugs.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Drugszaak,Drugslab": {
    description_value: "Drugslab,Het aantreffen van een drugslaboratorium.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Drugszaak,Wietplantage": {
    description_value: "Wietplantage,Het aantreffen van hennep- en wietplantages.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Explosief/Munitie,": {
    description_value: "Explosief/munitie,Het aantreffen van een explosief of munitie, niet zijnde het gebruik hiervan.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Explosief/Munitie,Aantref. explosieven": {
    description_value: "Aantreffen explosieven,Het aantreffen van explosieven.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Explosief/Munitie,Bommelding": {
    description_value: "Bommelding,Een melding waarbij gedreigd wordt tot het gebruik van een explosief.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Explosief/Munitie,Explosie": {
    description_value: "Explosie,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Explosief/Munitie,Munitie": {
    description_value: "Munitie,Het aantreffen van vuurwapens en/of munitie.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Explosief/Munitie,Vuurwerkopslag": {
    description_value: "Vuurwerkopslag,Het aantreffen van (illegaal) vuurwerk.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Gevangenis,": {
    description_value: "V & O orde gevangenis,Een gebouw om gedetineerden in bewaring te stellen of in hechtenis te nemen.,Deze vallen in Nederland onder de Dienst Justitiele Inrichtingen.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Gevangenis,Ontsnapping": {
    description_value: "Gevangenis ontsnapping,Het zonder toestemming verlaten van de gevangenis.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Gevangenis,Oproer": {
    description_value: "Gevangenisoproer,Een melding van verzet, onrust door meerdere personen in een gevangenis.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Geweld,": {
    description_value: "Geweld,Het opzettelijk, door middel van het toepassen van geweld, toebrengen van pijn of letsel aan personen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Geweld,Bedreiging": {
    description_value: "Bedreiging,Het verbaal bedreigen van personen met het toebrengen van schade, pijn of letsel zonder dit daadwerkelijk al te hebben uitgevoerd.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Geweld,CBRN-e dreiging": {
    description_value: "CBRN-e dreiging,De dreiging van chemische, biologische, radioactieve, nucleaire stoffen/wapens waarbij pijn of letsel kan ontstaan.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Geweld,Gijzeling": {
    description_value: "Gijzeling,Personen met geweld of bedreiging met geweld tegen hun wil vasthouden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Geweld,Kaping": {
    description_value: "Kaping,Het met geweld of dreiging met geweld het commando overnemen van een voertuig, vaartuig, of luchtvaartuig.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Geweld,Mishandeling": {
    description_value: "Mishandeling,Het opzettelijk toebrengen van pijn of letsel aan een ander.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Geweld,Ontvoering": {
    description_value: "Ontvoering,Iemand tegen diens wil onttrekken uit zijn/haar vertrouwde omgeving en wederrechtelijk verplaatsen/wegvoeren.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Geweld,Schietpartij": {
    description_value: "Schietpartij,Een vuurgevecht door middel van vuurwapens tussen of gericht tegen personen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Geweld,Steekpartij": {
    description_value: "Steekpartij,Het gebruiken van steekwapens gericht tegen personen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Geweld,Terrorisme": {
    description_value: "Terrorisme,Op de meldkamer geeft de politie aan of een incident als terrorisme geclassificeerd moet worden. Het betreffen acties met oogmerk om de bevolking of een deel van de bevolking van een land vrees aan te jagen, dan wel een overheid of internationale organisatie te dwingen iets te doen, niet te doen of te dulden, dan wel de fundamentele politieke, constitutionele, economische of sociale structuren van een land of een internationale organisatie ernstig te ontwrichten of te vernietigen. (bron: AIVD) Deze definitie die het gevolg is van het Europese standpunt van de Raad van de Europese Unie inzake terrorismebestrijding, zoals deze materieel gelijk is beschreven in de bepaling in de (ontwerp-)WTM, artikel 83a WvSr: wet- en regelgeving Art. 83a WvSr en 140 WvSr hiërarchische verhouding,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Geweld,Vechtpartij": {
    description_value: "Vechtpartij,Door toepassing van lijfelijk geweld een geschil trachten te slechten.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Noodoproep,": {
    description_value: "Noodoproep,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Verdachte situatie,": {
    description_value: "Verdachte situatie,Een ongewone situatie die om nader onderzoek vraagt,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Verdachte situatie,Gebouw": {
    description_value: "Verdachte situatie gebouw,Een ongewone situatie in en om een gebouw die om nader onderzoek vraagt,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Verdachte situatie,Overleden persoon": {
    description_value: "Overleden persoon,Het aantreffen van een overleden persoon waarvan de identiteit niet direct kan worden vastgesteld en de doodsoorzaak vraagt om nader onderzoek.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Verdachte situatie,Pakket/Voorwerp": {
    description_value: "Verdacht pakket/voorwerp,Het aantreffen van een verdacht pakket of voorwerp.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Verdachte situatie,Persoon": {
    description_value: "Verdacht persoon,Het aantreffen van een persoon die verdacht is of verdacht gedraagt,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Verdachte situatie,Voertuig/Vaartuig": {
    description_value: "Verdacht voer-/vaartuig,Het aantreffen van een verdacht voertuig ,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Seksueel delict,": {
    description_value: "Seksueel delict,Een melding van een incident waarbij sprake is van een seksueel misdrijf,Kinderpornografie, seksueel misbruik van kinderen, verkrachting en aanranding zijn voorbeelden van seksuele misdrijven. Het Nederlandse Wetboek van Strafrecht bevat een speciaal deel waarin deze en andere seksuele misdrijven staan vermeld. De artikelen in dit deel van het wetboek geven aan wat er precies onder wordt verstaan en welke straf maximaal kan worden opgelegd. Kwetsbare personen zoals kinderen, verstandelijk gehandicapten en mensen die bewusteloos zijn of slapen worden extra beschermd tegen seksueel misbruik.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Seksueel delict,Aanranding": {
    description_value: "Aanranding,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Seksueel delict,Aanstootgevend gedrag": {
    description_value: "Aanstootgevend gedrag,Tonen geslachtsdeel (bijv potloodventer), kan ook live via internet,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Seksueel delict,Kinderpornografie": {
    description_value: "Kinderpornografie,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Seksueel delict,Ontucht minderjarigen": {
    description_value: "Ontucht minderjarigen,Het plegen van ontucht (seksuele handelingen) met een minderjarig persoon. Onder ontucht wordt hier ook verstaan het betasten van intieme delen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Seksueel delict,Prostitutie": {
    description_value: "Prostitutie,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Seksueel delict,Seksueel benaderen kind": {
    description_value: "Seksueel benaderen kind,Seksuele benadering van een kind, schriftelijk of mondeling (sexchatting of grooming),",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Seksueel delict,Seksueel misbruik kind": {
    description_value: "Seksueel misbruik kind,Seksuele handelingen met kind (verkrachting of aanranding kind).,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Seksueel delict,Seksuele intimidatie": {
    description_value: "Seksuele intimidatie,Seksuele intimidatie in het openbaar (op straat of online). Kan gaan om opmerkingen, geluiden, gebaren of aanrakingen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Veiligheid en openbare orde,Seksueel delict,Verkrachting": {
    description_value: "Verkrachting,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,,": {
    description_value: "Verkeer,Een verkeersgebeurtenis niet zijnde een ongeval.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Luchtvaart,": {
    description_value: "Verkeer Luchtvaart,Betreft alle luchtvaartvervoermiddelen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Luchtvaart,Laag vliegen": {
    description_value: "Laag vliegen,Het lager vliegen dan de voorgeschreven minimale hoogte.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Luchtvaart,Onbevoegd vliegen": {
    description_value: "Onbevoegd vliegen,Zonder daarvoor voorafgegane toestemming vliegen met een luchtvaartuig.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Luchtvaart,Onbevoegde landing": {
    description_value: "Onbevoegde landing,Zonder daarvoor voorafgegane toestemming op een luchtvaartterrein of ander terrein landen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Luchtvaart,Onder invloed": {
    description_value: "Luchtvaart onder invloed,Een luchtvaartuig besturen terwijl de gezagvoerder onder invloed van alcoholische drank of drugs verkeert.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Luchtvaart,Runway incursion": {
    description_value: "Runway incursion,Er is sprake van een runway incursion wanneer een vliegtuig, een voertuig of een persoon zich ten onrechte op de start- en of landingsbaan bevindt of binnen de beschermende zone daarvan.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Scheepvaart,": {
    description_value: "Verkeer scheepvaart,Incidenten die het vervoer op het water aangaan.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Scheepvaart,Aanmeerproblemen": {
    description_value: "Aanmeerproblemen,Er doen zich problemen voor bij het afmeren aan een steiger of kade of bij het ankeren.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Scheepvaart,Afgevallen lading": {
    description_value: "Scheepvaart afgev. lading,Lading dat van een schip is gevallen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Scheepvaart,ASO-vaargedrag": {
    description_value: "ASO-vaargedrag,Gedrag op het water waar anderen hinder van ondervinden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Scheepvaart,Hinderl. waterbeweging": {
    description_value: "Hinderlijke waterbeweging,Een vaartuig veroorzaakt een golfbeweging die hinder of schade veroorzaakt.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Scheepvaart,Onbevoegd varen": {
    description_value: "Onbevoegd varen,Het besturen van een vaartuig zonder in het bezit te zijn van de vereiste documenten.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Scheepvaart,Onder invloed": {
    description_value: "Scheepvaart onder invloed,Een vaartuig onder invloed van alcoholische drank of drugs besturen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Scheepvaart,Stremming": {
    description_value: "Scheepvaart stremming,Gedeeltelijke of gehele stremming van de vaarweg niet zijnde een ongeval,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Spoorvervoer,": {
    description_value: "Verkeer Spoorvervoer,Incidenten die het vervoer op of om het spoor aangaan.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Spoorvervoer,Defect meubilair": {
    description_value: "Defect meubilair spoor,Hulpmiddelen langs het spoor bijv. spoorwegbomen, seinpalen, seinborden die defect zijn.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Spoorvervoer,Loslopende dieren": {
    description_value: "Loslopende dieren spoor,Hulpmiddelen langs het spoor bijv. spoorwegbomen, seinpalen, seinborden die defect zijn.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Spoorvervoer,Negeren rood sein": {
    description_value: "Negeren rood sein,Een treinmachinist geeft geen gevolg aan een rood stopteken.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Spoorvervoer,Onder invloed": {
    description_value: "Onder invloed spoor,Een persoon bevindt zich onbevoegd op het spoor.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Spoorvervoer,Persoon o/b spoor": {
    description_value: "Persoon op/bij spoor,Een persoon bevindt zich onbevoegd op of bij het spoor of spoorbed.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Spoorvervoer,Stremming": {
    description_value: "Spoorvervoer stremming,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Spoorvervoer,Verstoring treindienst": {
    description_value: "Verstoring treindienst,Trein Incident Management onderscheid 4 gradaties van in toenemende mate ernstiger wordende verstoringen van de treindienst: TIS 1.1 t/m TIS 1.4 Zolang het geen ontsporing zonder slachtoffers, verstoring door slecht weer of door de overheid opgelegde verstoring treindienst is b.v. voor het ruimen van WO2 bom kunnen deze meldingen hieronder geplaatst worden.,Uitzonderlijke omstandigheden daargelaten is geen inzet van de overheidshulpdiensten nodig. Inzet van de overheidshulpdiensten kan nodig zijn als een trein op een overweg blijft staan, langdurig met zeer koud of warm weer met passagiers ergens op de baan moet blijven staan e.d.",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,": {
    description_value: "Wegverkeer,Betreft alle wegvervoermiddelen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Achtervolging": {
    description_value: "Achtervolging,,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Afgevallen lading": {
    description_value: "Wegverkeer afgev. lading,Lading dat van een voertuig is gevallen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,ASO-rijgedrag": {
    description_value: "ASO-rijgedrag,Gedrag op de weg waar anderen hinder van ondervinden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Bijz. Verk zaken": {
    description_value: "Bijzondere verkeerszaken,Bijzondere verkeerszaken bijv. extreem vervoer,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Defect straatmeubilair": {
    description_value: "Defect straatmeubilair,Hulpmiddelen langs de weg bijv. verkeersborden, lichtmasten, wegbebording, schrikhekken die defect of beschadigd zijn.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Fietser o/b rijbaan": {
    description_value: "Fietser op/bij rijbaan,Een fietser bevindt zich onbevoegd op of bij de rijbaan,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Gladheid": {
    description_value: "Gladheid wegen,Wegdek dat door atmosferische invloed glad is geworden of dreigt te worden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Joyriding": {
    description_value: "Joyriding,Het zonder toestemming van de eigenaar met een motorvoertuig over de voor het openbaar verkeer openstaande weg rijden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Loslopende dieren": {
    description_value: "Loslopende dieren op weg,Dieren die zonder een geleider op of langs de rijbaan van een weg lopen.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Onder invloed": {
    description_value: "Wegverkeer onder invloed,Een voertuig besturen terwijl de bestuurder onder invloed van alcoholische drank of drugs verkeert.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Parkeerprobleem": {
    description_value: "Parkeerprobleem,Er doen zich problemen voor door of met het parkeren van een voertuig.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Persoon o/b rijbaan": {
    description_value: "Persoon op/bij rijbaan,Een persoon bevindt zich onbevoegd op of bij de rijbaan,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Spookrijder": {
    description_value: "Spookrijder,Een bestuurder van een motorvoertuig rijdt tegen de rijrichting van het overige verkeer in.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Verkeersgeleiding": {
    description_value: "Verkeersgeleiding,Bestuurders krijgen een aanwijzing door middel van matrix- borden om een bepaalde snelheid te rijden of van een bepaalde rijstrook gebruik te maken.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Verkeersstremming": {
    description_value: "Verkeersstremming,De rijbaan is geheel of gedeeltelijk gestremd door een voorwerp of voertuig waardoor het verkeer niet of slechts gedeeltelijk door kan gaan.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  },
  "Meldingsclassificatie_Verkeer,Wegverkeer,Vervuild wegdek": {
    description_value: "Vervuild wegdek,Wegdekvervuiling door gelekte vloeistof, afvallende lading of loslatende modder van banden.,",
    type: "Ja/Nee",
    quesiton_definition: "",
    answer_definition: "",
    criterion_of_situation: "",
    criterion_of_action: "",
    remarks: "",
    comments: "",
    answer_options: [
      "Ja",
      "Nee"
    ]
  }
}

export default schema;